/* eslint-disable */
import axios, { AxiosInstance } from 'axios';
import { number } from 'echarts/core';
import {EditLog,IUploadskin,IDeviceModelList,ICreateTopScript,AppointmentCreat,AddBug,BaselinesCreate,TemplatesCreate,IUploadCpuReport,UploadTopPerformanceTop,ProblemSummay,ICpuStackMerge,IdeepDataCheck,IMemory,ISimpleTrend,ISimple,ICaseDetail,IControl,INzmUploadReport, ICopy,IUploadDcReportSimple,IMark,ITask, IUploadSmokeReporrt,IUserProfile, IUserProfileUpdate, IUserProfileCreate, IProject, IDevice, ITaskRecord, ITaskControl, IScript, IDeviceSpacs, IAccount, IPipeline, ITaskStatus, IPipelinePkg, IProjectScene, IProjectUser, IUser, ISceneScriptCreate, ITaskStat, IPerformance, ITaskRecordCom, IPerformanceCom,IPerDeepformanceCom,IPerformanceSelectOptions, IReport, IUploadReport, IPerformanceDashboard, IReportPage, IVisitStat,IDeepPerformanceSelectOptions, ITaskPages, IScriptPages, IDeviceNew, ICreateScript, IPerformanceAovEmail,UploadTopPerformance, UploadPerformance, UploadPerformanceAll, IScenePage, ITaskLog, ITOPReport, IUploadReportSimple, ITOPReportUpload, IReportMarkCPU, ISkinDetail } from './interfaces';

function authHeaders(token: string) {
  return {
    headers: {
      // 'Access-Token': "18610e234bb15ef72ee97f30b5d7c658",
      'Access-Token': token,
    },
  };
}
axios.defaults.baseURL = `/api/v1`
var instance1 = axios.create({
  baseURL: '',
});

const uploadAxios = axios.create({
  baseURL: 'https://memdump.pika.work', // 使用特定的上传地址作为 baseURL
});

export const api = {
  async logInGetToken(username: string, password: string, tapd_token: any, login_type: any) {
    return axios.get(`/auth/login/`, {
      params: {
        username: username,
        password: password,
        tapd_token: tapd_token !== null ? tapd_token : "",
        login_type: login_type !== null ? login_type : "web",
      }
    });
  },
  async logInGetWereportToken(wereport_token: string, ) {
    return axios.get(`/auth/wereport_login/`, {
      params: {
      wereport_token:wereport_token
      }
    });
  },
  async wechatLogInGetToken(code: string) {
    return axios.get(`/auth/wechat_login/`, {
      params: {
        code: code,
      }
    });
  },
  // 获取用户部门
  async getStaffInfo(token: string) {
    return instance1.post(`/ts:auth/tauth/info.ashx`, {}, authHeaders(token));
  },
  // async getStaffInfo(token: string) {
  //   return axios.post(`https://gr.woa.com/ts:auth/tauth/info.ashx`, {}, authHeaders(token));
  // },
  // 用户管理
  async getMe(token: string) {
    return axios.get<IUserProfile>(`/user/me/`, authHeaders(token));
  },
  async updateMe(token: string, data: IUserProfileUpdate) {
    return axios.put<IUserProfile>(`/user/me/`, data, authHeaders(token));
  },
  async getUsers(token: string) {
    return axios.get<IUser[]>(`/user/users/`, authHeaders(token));
  },
  async updateUser(token: string, username: string, data: IUserProfileUpdate) {
    return axios.put(`/user/user/${username}/`, data, authHeaders(token));
  },
  async createUser(token: string, data: IUserProfileCreate) {
    return axios.post(`/user/users/`, data, authHeaders(token));
  },
  async resetPassword(password: string, token: string) {
    return axios.post(`/reset-password/`, {
      new_password: password,
      token,
    });
  },
  async getMyLastProject(token: string) {
    return axios.get(`/user/my_last_project/`, authHeaders(token));
  },
  async updateMyLastProject(token: string, data: { last_visit_project: number }) {
    return axios.put(`/user/my_last_project/`, data, authHeaders(token));
  },

  //项目管理
  async getProjects(token: string, project: number) {
    return axios.get<IProject[]>(`/proj/projects/?project=${project}`, authHeaders(token));
  },
  async getProject(token: string, id: number, project: number) {
    return axios.get<IProject>(`/proj/project/${id}/?project=${project}`, authHeaders(token));
  },
  async updateProject(token: string, id: number, data: IProject) {
    return axios.put(`/proj/project/${id}/`, data, authHeaders(token));
  },
  async deleteProject(token: string, id: number) {
    return axios.delete(`/proj/project/${id}/`, authHeaders(token));
  },
  async createProject(token: string, data: IProject) {
    return axios.post(`/proj/projects/`, data, authHeaders(token));
  },
  async getGamesDate(token: string,type:any) {
    return axios.get(`/proj/games_subscription_date_list/?type=${type}`, authHeaders(token));
  },
  async getGamesTap(token: string,) {
    return axios.post(`/proj/taptap/`,{}, authHeaders(token));
  },
    async getHokIcon(token: string,project:number) {
      return axios.get(`/proj/sgame_icon/?project=${project}`, authHeaders(token));
    },
    async getHokSkinVersions(token: string,project:number) {
      return axios.get(`/report/skin_versions/?project=${project}`, authHeaders(token));
    },
    async getHokSkinDevices(token: string,project:number,type:any) {
      return axios.get(`/report/skin_device_list_v1/?project=${project}&type=${type}`, authHeaders(token));
    },
    async getHokSkinData(token: string,project:number,version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,page_size:any,is_pass:any, level?:any) {
      return axios.get(`/report/all_skin_data/?project=${project}&version=${version}&type=${type}&action=${action}&hero_skin=${hero_skin}&device=${device}&start_date=${start_date}&end_date=${end_date}&order_by=${order_by}&reverse=${reverse}&page=${page}&page_size=${page_size}&is_pass=${is_pass}&level=${level}`, authHeaders(token));
    },
    async getHokSkinDataPage(token: string,project:number,version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,is_pass:any) {
      return axios.get(`/report/all_skin_data_more/?project=${project}&version=${version}&type=${type}&action=${action}&hero_skin=${hero_skin}&device=${device}&start_date=${start_date}&end_date=${end_date}&order_by=${order_by}&reverse=${reverse}&page=${page}&is_pass=${is_pass}`, authHeaders(token));
    },
    async getHokSkinDataExport(token: string,project:number,version:any,type:any,action:any,hero_skin:any,device:any,start_date:any,end_date:any,order_by:any,reverse:any,page:any,page_size:any,is_pass:any) {
      return axios.get(`/report/all_skin_export/?project=${project}&version=${version}&type=${type}&action=${action}&hero_skin=${hero_skin}&device=${device}&start_date=${start_date}&end_date=${end_date}&order_by=${order_by}&reverse=${reverse}&page=${page}&page_size=${page_size}&is_pass=${is_pass}`,  { headers: { 'Access-Token': token}, responseType: 'blob' });
    },
    async getHokIn(token: string,project:number,skin_id:any, gender: any) {
      return axios.get(`/report/in_skin_data/?project=${project}&skin_id=${skin_id}&gender=${gender}`, authHeaders(token));
    },
    async getHokInV1(token: string,project:number,skin_id:any) {
      return axios.get(`/report/in_skin_data_v1/?project=${project}&skin_id=${skin_id}`, authHeaders(token));
    },
    async getHokInAdd(token: string,project:number,skin_id:any,device_name:any,page:any,quality:any) {
      return axios.get(`/report/in_skin_data_more/?project=${project}&skin_id=${skin_id}&device_name=${device_name}&page=${page}&quality=${quality}`, authHeaders(token));
    },
    async getHokInAddV1(token: string,project:number,skin_id:any,device_name:any,page:any) {
      return axios.get(`/report/in_skin_data_more_v1/?project=${project}&skin_id=${skin_id}&device_name=${device_name}&page=${page}`, authHeaders(token));
    },
    async getHokOutAddV1(token: string,project:number,skin_id:any,device_name:any,page:any,action:any) {
      return axios.get(`/report/skin_data_more_v1/?project=${project}&skin_id=${skin_id}&device_name=${device_name}&page=${page}&action=${action}`, authHeaders(token));
    },
    async getHokOutAdd(token: string,project:number,skin_id:any,device_name:any,page:any,action:any) {
      return axios.get(`/report/skin_data_more/?project=${project}&skin_id=${skin_id}&device_name=${device_name}&page=${page}&action=${action}`, authHeaders(token));
    },
    async getHokOut(token: string,project:number,skin_id:any,gender?:any) {
      return axios.get(`/report/skin_data/?project=${project}&skin_id=${skin_id}&gender=${gender}`, authHeaders(token));
    },
    async getHokOutV1(token: string,project:number,skin_id:any) {
      return axios.get(`/report/skin_data_v1/?project=${project}&skin_id=${skin_id}`, authHeaders(token));
    },
    async getHokDeviceList(token: string,project:number,skin_id:any,type:any) {
      return axios.get(`/report/skin_device_list/?project=${project}&skin_id=${skin_id}&type=${type}`, authHeaders(token));
    },
    async getModelList(token: string,search:any,oem:any,cpu_name:any,ram:any,borrower:any,page:any,size:any,gpu:any) {
      return axios.get(`/device/model_list/?search=${search}&oem=${oem}&cpu_name=${cpu_name}&ram=${ram}&borrower=${borrower}&page=${page}&size=${size}`, authHeaders(token));
    },
    async getModelOptions(token: string,project:number,) {
      return axios.get(`/device/model_options/?project=${project}`, authHeaders(token));
    },
    async getHokInSkinTrend(token: string,project:number,skin_id:any,device_id:any,quality:any,gender?:any) {
      return axios.get(`/report/in_skin_trend/?project=${project}&skin_id=${skin_id}&device_id=${device_id}&quality=${quality}&gender=${gender}`, authHeaders(token));
    },
    async getModelCreate(token: string,data:IDeviceModelList) {
      return axios.post(`/device/model_list/`,data, authHeaders(token));
    },
    async getModelEdit(token: string,data:IDeviceModelList) {
      return axios.put(`/device/model/${data.id}/`,data, authHeaders(token));
    },
    async getModelStatus(token: string,data:{status:any,id:any,return_time?:any}) {
      return axios.put(`/device/model_status_update/${data.id}/`,data, authHeaders(token));
    },
    async getHokOutSkinTrend(token: string,project:number,skin_id:any,action:any,device_id:any,quality:any,gender?:any) {
      return axios.get(`/report/skin_trend/?project=${project}&skin_id=${skin_id}&action=${action}&device_id=${device_id}&quality=${quality}&gender=${gender}`, authHeaders(token));
    },
  async getGameData(token: string,date:string,last:string,type:any) {
    return axios.get(`/proj/games_subscription/?date=${date}&last=${last}&type=${type}`, authHeaders(token));
  },

  async getMyProjects(token: string) {
    return axios.get<IProject[]>(`/proj/myprojects/`, authHeaders(token));
  },
  async projectAccess(token: string) {
    return axios.get(`/proj/project_access/`, authHeaders(token),);
  },
  async cloneProject(token: string, data: {old_project: number, new_project: number, clone_list: string[]}) {
    return axios.post(`/proj/project_clone/`, data, authHeaders(token));
  },
  // 项目配置
  async resetProject(token: string, data: { project: number, file: any; project_name: string; pkg_name: string;ios_pkg_name:string }) {
    return axios.post(`/proj/project_icon/`, data, authHeaders(token));
  },
  // 新增项目
  async createProjProjects(token: string, data: { project: number, file: any; project_key: string; project_name: string; pkg_name: string; b_invite: number;ios_pkg_name:string }) {
    return axios.post(`/proj/projects/`, data, authHeaders(token));
  },
  async getGamesSubscription(token: string, data: { url:string,p_skey:string,skey:string}) {
    return axios.post(`/proj/games_subscription/`, data, authHeaders(token));
  },
  // 统计
  async getReportStat(token: string, project: number, search: any | '', size: number | string, page: number) {
    if (search) {
      return axios.get(`/stat/report_statistics/?project=${project}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
    } else {
      return axios.get(`/stat/report_statistics/?project=${project}&size=${size}&page=${page}`, authHeaders(token));
    }
  },

  // 记录
  async getVisitStatistics(token: string, project: number, search: any | '', size: number | string, page: number) {
    if (search) {
      return axios.get(`stat/visit_statistics/?search=${search}&size=${size}&page=${page}`, authHeaders(token));
    } else {
      return axios.get(`stat/visit_statistics/?project=${project}&size=${size}&page=${page}`, authHeaders(token));
    }
  },

  // 趋势
  async getVisitStatTrend(token: string, start_date: any, end_date: any) {
    return axios.get(`/stat/visit_stat_trend/?start_date=${start_date}&end_date=${end_date}`, authHeaders(token));
  },
  async addVisitStat(token: string, data: any) {
    return axios.post(`/stat/visit_statistics/`, data, authHeaders(token));
  },
  // 平台监控
  async getMonitorTrend(token: string, start_date: any, end_date: any){
    return axios.get(`/monitor/monitor_api_trend/?start_date=${start_date}&end_date=${end_date}`, authHeaders(token));
  },
  async getMonitorUploadTrend(token: string,project:number, start_date: any, end_date: any,){
    return axios.get(`/monitor/monitor_upload_trend/?project=${project}&start_date=${start_date}&end_date=${end_date}`, authHeaders(token));
  },
  async getmonitorList(token: string,project: number, date: any,size: number | string, page: number,api:string){
    return axios.get(`/monitor/monitor_api_list/?project=${project}&date=${date}&size=${size}&page=${page}&api=${api}`, authHeaders(token));
  },
  async getmonitorUploadList(token: string,project: number, date: any,size: number | string, page: number,api:string){
    return axios.get(`/monitor/monitor_upload_list/?project=${project}&date=${date}&size=${size}&page=${page}&api=${api}`, authHeaders(token));
  },

  //项目用户
  async getProjectUsers(token: string, project: number) {
    return axios.get<IProjectUser[]>(`/proj/project_users/?project=${project}`, authHeaders(token));
  },
  async getProjectUsersPages(token: string, project: number) {
    return axios.get(`/user/user_pages/?project=${project}`, authHeaders(token));
  },
  async updateProjectUsers(token: string, data: { project: number, project_user: any[] }) {
    return axios.put(`/proj/project_user/`, data, authHeaders(token));
  },
  async createProjectUser(token: string, data: IProjectUser) {
    return axios.post(`/proj/myprojects/`, data, authHeaders(token));
  },
  async updateProjectUser(token: string, data: IProjectUser) {
    return axios.put(`/proj/project_user_detail/${data.id}/`, data, authHeaders(token));
  },
  async deleteProjectUser(token: string, id: number,project:number) {
    return axios.delete(`/proj/project_user_detail/${id}/?project=${project}`, authHeaders(token));
  },
  async addProjectUser(token: string, data: { project: number, username: string, is_project_admin: boolean }) {
    return axios.put(`/proj/add_project_user/`, data, authHeaders(token));
  },
  async removeProjectUser(token: string, data: { project: number, username: string }) {
    return axios.put(`/proj/remove_project_user/`, data, authHeaders(token));
  },

  //项目场景
  async getProjectScenes(token: string, project: number) {
    return axios.get<IProjectScene[]>(`/proj/project_scenes/?project=${project}`, authHeaders(token));
  },
  async getTopProjectScenes(token: string, project: number) {
    return axios.get(`/top/project_list/?project=${project}`, authHeaders(token));
  },
  async getProjectScenesPage(token: string, project: number, page: number, size: number, search: string) {
    return axios.get<IScenePage>(`/proj/project_scenes_page/?project=${project}&page=${page}&size=${size}&search=${search}`, authHeaders(token));
  },
  async getProjectSgameSkinList(token: string, project: number, page: number, size: number, search: string) {
    return axios.get(`/proj/sgame_skin_list/?project=${project}&page=${page}&size=${size}&search=${search}`, authHeaders(token));
  },
  async getCreateProjectSgameSkinList(token: string, data:{project: number, skinid: any, heroid: any, heroname: string,skin:any,skinname:any,desc:any,level:any,gender: any}) {
    return axios.post(`/proj/sgame_skin_list/`,data, authHeaders(token));
  },
  async updateProjectScene(token: string, data: IProjectScene) {
    return axios.put(`/proj/project_scene/${data.id}/`, data, authHeaders(token));
  },
  async updateSgameSkin(token: string, data: {project:any,id:any,skinid:any,heroid:any,heroname:any,skin:any,skinname:any,desc:any,level:any, gender: any}) {
    return axios.put(`/proj/sgame_skin/${data.id}/`, data, authHeaders(token));
  },
  async updateSkinTab(token: string, data: {project:any,id:any,tab_name:string,start_date:any,end_date:any,skin_list:any}) {
    return axios.put(`/report/skin_tab/${data.id}/`, data, authHeaders(token));
  },
  async createProjectScenes(token: string, data: ICreateScript) {
    return axios.post(`/proj/project_scenes/`, data, authHeaders(token));
  },
  async createTopProjectScenes(token: string, data: ICreateTopScript) {
    return axios.post(`/top/project_list/`, data, authHeaders(token));
  },
  async deleteProjectScene(token: string, id: number, project: number) {
    return axios.delete(`/proj/project_scene/${id}/?project=${project}`, authHeaders(token));
  },
  async deleteSgameSkin(token: string, id: number, project: number) {
    return axios.delete(`/proj/sgame_skin/${id}/?project=${project}`, authHeaders(token));
  },

  // 任务管理
  async getTasks(token: string, project: number, page: number, size: number, task_name: string) {
    return axios.get<ITaskPages>(`/task/tasks/?project=${project}&page=${page}&size=${size}&task_name=${task_name}`, authHeaders(token));
  },
  async getTaskRecordProject(token: string, task_record_id: number) {
    return axios.get(`/task/task_record_project/?task_record_id=${task_record_id}`, authHeaders(token));
  },
  async getCustomTest(token: string) {
    return axios.get(`/custom/test/`, authHeaders(token));
  },
  async deleteTask(token: string, task_id: number, project: number) {
    return axios.delete(`/task/task/${task_id}/?project=${project}`, authHeaders(token));
  },
  async createTask(token: string, data: ITask) {
    return axios.post(`/task/tasks/`, data, authHeaders(token));
  },
  async copyTask(token: string, data: ICopy) {
    return axios.post(`/proj/task_clone/`, data, authHeaders(token));
  },
  async updateTask(token: string, id: number, data: ITask) {
    return axios.put(`/task/task/${id}/`, data, authHeaders(token));
  },
  async runTask(token: string, data: ITaskControl) {
    return axios.put(`/task/task_control/`, data, authHeaders(token));
  },

  async getTaskStats(token: string, project: number) {
    return axios.get<ITaskStat[]>(`/task/task_stats/?project=${project}`, authHeaders(token));
  },
  async getSgameChinaStatistics(token: string, project: number, start_date: string, end_date: string) {
    return axios.get(`/performance/sgame_china_statistics/?project=${project}&start_date=${start_date}&end_date=${end_date}`, authHeaders(token));
  },
  async getPerformanceVersions(token: string, project: number) {
    return axios.get(`/performance/versions/?project=${project}`, authHeaders(token));
  },
  async getPerformanceVersionsCreate(token: string, data:{project: number,version:string}) {
    return axios.post(`/performance/versions/`,data, authHeaders(token));
  },
  async getMobaProjects(token: string, project: number) {
    return axios.get<number[]>(`/common/moba_projects/?project=${project}`, authHeaders(token));
  },
  async getHeroSkin(token: string, project: number) {
    return axios.get(`/common/hero_skin_config/?project=${project}`, authHeaders(token));
  },
  async getTaskLogs(token: string, project: number, task_record_id: number) {
    return axios.get<ITaskLog[]>(`/task/task_log/?project=${project}&task_record_id=${task_record_id}`, authHeaders(token));
  },

  // 任务记录
  async getTaskRecords(token: string, project: number) {
    return axios.get<ITaskRecord[]>(`/task/task_records/?project=${project}`, authHeaders(token));
  },
  async getSimpleTaskRecords(token: string, project: number, task_name: string, task_status: number | "", create_user: string, page: number, size: number) {
    return axios.get<ITaskRecordCom>(`/task/simple_task_records/?project=${project}&task_name=${task_name}&task_status=${task_status}&create_user=${create_user}&page=${page}&size=${size}`, authHeaders(token));
  },
  async getTaskRecord(token: string, project: number, record_id: number) {
    return axios.get<ITaskRecord>(`/task/task_record/${record_id}/?project=${project}`, authHeaders(token));
  },

  // 场景脚本
  async getScripts(token: string, project: number, scene?: number | null, page?: number, size?: number, script_name?: string) {
    if (scene) {
      return axios.get<IScriptPages>(`/task/scripts/?project=${project}&page=${page}&size=${size}&script_name=${script_name}&scene=${scene}`, authHeaders(token));
    } else {
      return axios.get<IScriptPages>(`/task/scripts/?project=${project}&page=${page}&size=${size}&script_name=${script_name}`, authHeaders(token));
    }
  },
  async getScripts_content(token: string, script_id:number,project: number,) {

      return axios.get(`/task/script/${script_id}/?project=${project}`, authHeaders(token));

  },
  async getSimpleScripts(token: string, project: number, scene?: number | null) {
    if (scene) {
      return axios.get<IScript[]>(`/task/simple_scripts/?project=${project}&scene=${scene}`, authHeaders(token));
    } else {
      return axios.get<IScript[]>(`/task/simple_scripts/?project=${project}`, authHeaders(token));
    }

  },
  async createScript(token: string, data: IScript) {
    return axios.post(`/task/scripts/`, data, authHeaders(token));
  },
  async createSceneScript(token: string, data: ISceneScriptCreate) {
    return axios.post(`/task/scene_script_create/`, data, authHeaders(token));
  },
  async createSceneScriptTop(token: string, data: ISceneScriptCreate) {
    return axios.post(`/top/top_list/`, data, authHeaders(token));
  },
  async updateScript(token: string, id: number, data: IScript) {
    return axios.put(`/task/script/${id}/`, data, authHeaders(token));
  },
  async deleteScript(token: string, script_id: number, project: number) {
    return axios.delete(`/task/script/${script_id}/?project=${project}`, authHeaders(token));
  },

  // Common公共
  async getTaskstatus(token: string, project: number) {
    return axios.get<ITaskStatus>(`/common/common_taskstatus/?project=${project}`, authHeaders(token));
  },
  async getAllIndexes(token: string, project: number) {
    return axios.get<string[]>(`/common/all_indexes/?project=${project}`, authHeaders(token));
  },
  async AccessUrl(token: string, project: number, report_id: number) {
    return axios.get(`/common/access_url/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },

  // 设备管理
  async getDevices(token: string, project: number) {
    return axios.get<IDevice[]>(`/device/devices/?project=${project}`, authHeaders(token));
  },
  async updateDevice(token: string, data: IDevice) {
    return axios.put(`/device/device/${data.id}/`, data, authHeaders(token));
  },
  async updateSystem(token: string, data: IDevice) {
    return axios.put(`/device/device_specs/${data.model}/`, data, authHeaders(token));
  },
  async createDevice(token: string, data: IDevice) {
    return axios.post(`/device/device_register/`, data, authHeaders(token));
  },
  async deleteDevice(token: string, id: number, project: number) {
    return axios.delete(`/device/device/${id}/?project=${project}`, authHeaders(token));
  },
  // 释放设备按钮
  async releaseDevice(token: string, UUID: any, project: number) {
    return axios.get(`/device/device_status_update/?project=${project}&UUID=${UUID}`, authHeaders(token));

  },
  async getDeviceSpecs(token: string, project: number) {
    return axios.get<IDevice[]>(`/device/device_specs/?project=${project}`, authHeaders(token)); //设备详情列表
  },
  async getDeviceSpecsNew(token: string, project: number, size: number, page: number, search?: string) {
    return axios.get<IDeviceNew>(`device/device_page_list/?project=${project}&size=${size}&page=${page}&search=${search}`, authHeaders(token)); //设备详情列表
  },
  async GetDeviceSpecsList(token: string, project: number) {
    return axios.get<IDeviceSpacs[]>(`/device/device_specs_list/?project=${project}`, authHeaders(token));  //设备规格列表
  },
  // 注册设备
  async createDeviceSpecsList(token: string, data: IDeviceSpacs) {
    return axios.post(`/device/device_specs_list/`, data, authHeaders(token));
  },

  // 账户管理
  async getAccounts(token: string, project: number) {
    return axios.get<IAccount[]>(`/account/accounts/?project=${project}`, authHeaders(token));
  },
  async updateAccount(token: string, data: IAccount, id: number) {
    return axios.put(`/account/account/${id}/`, data, authHeaders(token));
  },
  async createAccount(token: string, data: IAccount) {
    return axios.post(`/account/accounts/`, data, authHeaders(token));
  },
  async deleteAccount(token: string, id: number, project: number) {
    return axios.delete(`/account/account/${id}/?project=${project}`, authHeaders(token));
  },

  // 流水线
  async getPipelines(token: string, project: number) {
    return axios.get<IPipeline[]>(`/pipeline/pipeline/?project=${project}`, authHeaders(token));
  },
  async createPipeline(token: string, data: IPipeline) {
    return axios.post(`/pipeline/pipeline/`, data, authHeaders(token));
  },
  async updatePipeline(token: string, data: IPipeline) {
    return axios.put(`/pipeline/update_pipeline/`, data, authHeaders(token));
  },
  // async updatePipeline(token: string, data: IPipeline, pipeline_key: string) {
  //   return axios.put(`/pipeline/pipeline/${pipeline_key}/`, data, authHeaders(token));
  // },
  async deletePipeline(token: string, pipeline_key: string, project: number) {
    return axios.delete(`/pipeline/pipeline/${pipeline_key}/?project=${project}`, authHeaders(token));
  },
  async getPipelinePkgs(token: string, project: number, pipeline_id: string | null) {
    if (pipeline_id) {
      return axios.get<IPipelinePkg[]>(`/pipeline/pipeline_pkg/?project=${project}&pipeline_id=${pipeline_id}`, authHeaders(token));
    } else {
      return axios.get<IPipelinePkg[]>(`/pipeline/pipeline_pkg/?project=${project}`, authHeaders(token));
    }
  },
  async updatePipelinePkg(token: string, data: IPipelinePkg) {
    return axios.put(`/pipeline/pipeline_pkg_detail/${data.id}/`, data, authHeaders(token));
  },
  async deletePipelinePkg(token: string, pkg_id: number, project: number) {
    return axios.delete(`/pipeline/pipeline_pkg_detail/${pkg_id}/?project=${project}`, authHeaders(token));
  },
  async downloadPkg(token: string, project: number, pipeline_download_id: any) {
    return axios.get(`/pipeline/pipeline_pkg/download_pkg/${pipeline_download_id}/?project=${project}`, authHeaders(token));
  },

  // 客户端性能
  async getPerformances(token: string, project: number, task_record_id: number | "", scene_id: number | "", device_id: number | "") {
    return axios.get<IPerformance[]>(`/performance/performances/?project=${project}&task_record_id=${task_record_id}&scene_id=${scene_id}&device_id=${device_id}`, authHeaders(token));
  },
  // 上传性能数据
  async uploadPerformance(token: string, data: UploadPerformance) {
    return axios.post(`/performance/perdog_upload/`, data, authHeaders(token));
  },
  async uploadDeepCpuUpload(token: string, data: UploadPerformance) {
    return axios.post(`/deep_performance/flame_graph_upload/`, data, authHeaders(token));
  },
  async uploadTopPerformance(token: string, data: UploadTopPerformance) {
    return axios.post(`/performance/top_perdog_upload/`, data, authHeaders(token));
  },
  async addBug(token: string, data: AddBug) {
    return axios.post(`/performance/add_bug/`, data, authHeaders(token));
  },
  async problemSummay(token: string, project: number, id_list: any,project_name:string ) {
    return axios.get(`/performance/problem_summary/?project=${project}&id_list=${id_list}&project_name=${project_name}`,authHeaders(token));
  },
  async topTemplates(token: string, project: number ) {
    return axios.get(`/performance/top_templates/?project=${project}`,authHeaders(token));
  },
  async topBaselines(token: string, project: number ) {
    return axios.get(`/performance/top_baselines/?project=${project}`,authHeaders(token));
  },
  async uploadTopPerformanceUpload(token: string, data: UploadTopPerformanceTop) {
    return axios.post(`/performance/top_upload/`, data, authHeaders(token));
  },
  async uploadTopPerformanceModelUpload(token: string, data: {project:any,file:any}) {
    return axios.post(`/device/model_excel_upload/`, data, authHeaders(token));
  },
  async uploadTopPerformanceTable(token: string, data: UploadTopPerformanceTop) {
    return axios.post(`/performance/top_export/`, data, { headers: { 'Access-Token': token}, responseType: 'blob' });
  },
  async topTemplatesCreate(token: string, data: TemplatesCreate) {
    return axios.post(`/performance/top_templates/`, data, authHeaders(token));
  },
  async topBaselinesCreate(token: string, data: BaselinesCreate) {
    return axios.post(`/performance/top_baselines/`, data, authHeaders(token));
  },
  async topTemplatesData(token: string,id:any,project:number) {
    return axios.get(`/performance/top_template/${id}/?project=${project}`, authHeaders(token));
  },
  async topBaselinesData(token: string,id:any,project:number) {
    return axios.get(`/performance/top_baseline_detail/${id}/?project=${project}`, authHeaders(token));
  },
  async topTemplatesEdit(token: string, data: TemplatesCreate) {
    return axios.put(`/performance/top_template/${data.id}/`, data, authHeaders(token));
  },
  async topBaselinesEdit(token: string, data: BaselinesCreate) {
    return axios.put(`/performance/top_baseline_detail/${data.id}/`, data, authHeaders(token));
  },
  // 上传runmax性能数据
  async uploadPerformanceAll(token: string, data: UploadPerformanceAll,) {
    return axios.post(`/performance/performance_upload_all/`, data, authHeaders(token));
  },
  async deepNzmSimpleRetry(token: string, data: IdeepDataCheck,) {
    return axios.post(`/deep_performance/nzm_simple_retry/`, data, authHeaders(token));
  },
  async deepFlameRetry(token: string, data: IdeepDataCheck,) {
    return axios.post(`/deep_performance/flame_graph_retry/`, data, authHeaders(token));
  },
  // 废弃: 获取所有的性能数据，包括无效的is_valid, 可使用is_valid过滤
  async getAllPerformances(token: string, project: number, is_valid: boolean | "") {
    return axios.get<IPerformance[]>(`/performance/all_performances/?project=${project}&is_valid=${is_valid}`, authHeaders(token));
  },
  async getPerformancePageList(token: string, project: number, task_record_id: any, scene_id_list: number[] | [], device_id_list: number[] | [], game_versions: string[] | [], page: number | "", size: number | string,is_valid?:number|"",custom_versions?:string) {

    return axios.get<IPerformanceCom>(`/performance/performance_page_list/?project=${project}&task_record_id=${task_record_id}&scene_id_list=${scene_id_list}&device_id_list=${device_id_list}&is_valid=${is_valid}&game_versions=${game_versions}&page=${page}&size=${size}&custom_versions=${custom_versions}`, authHeaders(token));
  },
  async getPerformancePageListSummary(token: string, project: number,date:string,task_record_id: any, scene_id_list: number[] | [], device_id_list: number[] | '', game_versions: string[] | [], page: number | "", size: number | string,is_valid?:number|"",is_deep?:number|"",type?:any,subtype?:any) {

    return axios.get<IPerformanceCom>(`/performance/performance_page_list_v1/?project=${project}&date=${date}&task_record_id=${task_record_id}&scene_id_list=${scene_id_list}&device_id_list=${device_id_list}&is_valid=${is_valid}&game_versions=${game_versions}&is_deep=${is_deep}&page=${page}&size=${size}&type=${type}&subtype=${subtype}`, authHeaders(token));
  },
  async getPerformanceSelectOptions(token: string, project: number) {
    return axios.get<IPerformanceSelectOptions>(`/performance/performance_select_options/?project=${project}`, authHeaders(token));
  },
  async getPerformanceCustomVersionList(token: string, project: number) {
    return axios.get(`/performance/custom_version_list/?project=${project}`, authHeaders(token));
  },
  async getDateVersionList(token: string, project: number,report_type?:number|null) {
    if(report_type){
      return axios.get<IPerformanceSelectOptions>(`/performance/date_versions/?project=${project}&report_type=${report_type}`, authHeaders(token));
    }else{
      return axios.get<IPerformanceSelectOptions>(`/performance/date_versions/?project=${project}`, authHeaders(token));
    }

  },
  async getPerformanceTableFields(token: string, project: number,) {
    return axios.get(`/performance/performance_table_fields/?project=${project}`, authHeaders(token));
  },
  async getPerformanceAnalysis(token: string, project: number, game_version: any, scene_id: number, device_id: string) {
    return axios.get(`/performance/performance_analysis/?project=${project}&game_version=${game_version}&scene_id=${scene_id}&device_id=${device_id}`, authHeaders(token));
  },
  async getPerformanceAovTrend(token: string, project: number, task_record_id: number) {
    return axios.get(`/performance/aov_trend/?project=${project}&task_record_id=${task_record_id}`, authHeaders(token));
  },
  async getPerformanceAovEmail(token: string, data: IPerformanceAovEmail) {
    return axios.post(`/performance/aov_custom_email/`, data, authHeaders(token));
  },
  async getAovPerformances(token: string, project: number, task_record_id: number, interval: number) {
    return axios.get(`/performance/aov_performances/?project=${project}&task_record_id=${task_record_id}&interval=${interval}`, authHeaders(token));
  },
  async taskRecordQuery(token: string, project: number, task_record_id: number) {
    return axios.get(`/task/task_record_query/?project=${project}&task_record_id=${task_record_id}`, authHeaders(token));
  },
  async taskRecordDevices(token: string, project: number, task_record_id: number) {
    return axios.get(`/task/task_record_devices/?project=${project}&task_record_id=${task_record_id}`, authHeaders(token));
  },
  async aovPerformanceCopy(token: string, project: number, from: number, to: number, device: any) {
    return axios.get(`/performance/aov_performance_copy/?project=${project}&from=${from}&to=${to}&device=${device}`, authHeaders(token));
  },
  async getLastRecord(token: string, project: number) {
    return axios.get(`/task/last_record/?project=${project}`, authHeaders(token));
  },
  async getRecentTaskrecord(token: string, project: number,report_type?:number|string,is_memory?:number) {
    if(report_type){
      return axios.get(`/task/recent_taskrecord/?project=${project}&report_type=${report_type}`, authHeaders(token));
    }if(is_memory){
      return axios.get(`/task/recent_taskrecord/?project=${project}&is_memory=${is_memory}`, authHeaders(token));
    }
    else{
      return axios.get(`/task/recent_taskrecord/?project=${project}`, authHeaders(token));
    }

  },

  // 数据有效
  async dataValid(token: string, id: number, data: IPerformance) {
    return axios.put(`/performance/performance/${id}/`, data, authHeaders(token));
  },
  //
  async reportCpuMark(token: string, data: IReportMarkCPU) {
    return axios.post(`/performance/report_cpu_mark/`, data, authHeaders(token));
  },

  // 项目概况
  async getPerformanceDashboard(token: string, project: number, scene_id: number | "",trend_type:any,start:any,end:any,report_type:number,subtype:number) {
    return axios.get<IPerformanceDashboard>(`/performance/performance_dashboard/?project=${project}&scene_id=${scene_id}&trend_type=${trend_type}&start=${start}&end=${end}&report_type=${report_type}&subtype=${subtype}`, authHeaders(token));
  },

  // runmax
  async getTestInfo(token: string, project: number, id: number) {
    return axios.get(`/performance/test_info/?project=${project}&id=${id}`, authHeaders(token));
  },
  async getLabelInfo(token: string, project: number, id_test: number) {
    return axios.get(`/performance/label_info/?project=${project}&id_test=${id_test}`, authHeaders(token));
  },
  async getLabelInfoLabel(token: string, project: number, id_test: number,id_label:any) {
    return axios.get(`/performance/label_info/?project=${project}&id_test=${id_test}&id_label=${id_label}`, authHeaders(token));
  },
  async getPerfAvgData(token: string, project: number, id_test: number, id_label:string[]) {
    //return axios.get(`/performance/label_avg_data/?project=${project}&id_test=${id_test}&id_label=${id_label}`, authHeaders(token));
    return axios.post(`/performance/label_avg_data/`, {
      project,
      id_test,
      id_label,
    })
  },
  async getperfInfo(token: string, id_test: number) {
    return axios.get(`/performance/perf_info/?id_test=${id_test}`, authHeaders(token));
  },
  async getPerfSecondData(token: string, project: number, id_test: number, id_label:string[]) {
    return axios.get(`/performance/cperf_second_data/?project=${project}&id_test=${id_test}&id_label=${id_label}`, authHeaders(token));
  },
  async getPerfIdTest(token: string,task_record_id: number, task_group_index:number,device_id:number) {
    return axios.get(`/performance/id_test/?task_record_id=${task_record_id}&task_group_index=${task_group_index}&device_id=${device_id}`, authHeaders(token));
  },
  async downloadCsv(token: string, project: number, id_test: number) {
    return axios.get(`/performance/download_csv/?project=${project}&id_test=${id_test}`, { headers: { 'Access-Token': token, responseType: 'blob' } });
  },
  async removeCsv(token: string, project: number, id_test: number) {
    return axios.get(`/performance/remove_csv/?project=${project}&id_test=${id_test}`, authHeaders(token));
  },

  // 报告
  async getReportList(token: string, project: number, page: number, size: number, report_name: string, new_version: string, old_version: string, risk: string, creator: string) {
    return axios.get<IReportPage>(`/report/perf_reports/?project=${project}&page=${page}&size=${size}&report_name=${report_name}&new_version=${new_version}&old_version=${old_version}&risk=${risk}&creator=${creator}`, authHeaders(token));
  },
  async createReport(token: string, data: any) {
    return axios.post(`/report/perf_reports/`, data, authHeaders(token));
  },
  async createReportByTask(token: string, data: any) {
    return axios.post(`/report/auto_task_report/`, data, authHeaders(token));
  },
  async updateReport(token: string, data: IReport) {
    return axios.put(`/report/report_detail/${data.id}/`, data, authHeaders(token));
  },
  async updateComReport(token: string, data: IReport) {
    return axios.put(`/report/codm_report_detail/${data.id}/`, data, authHeaders(token));
  },
  async performanceMake(token: string, data:IMark) {
    return axios.put(`/performance/performance_mark_batch/`, data, authHeaders(token));
  },
  async SimpleupdateReport(token: string, data:ISimple) {
    return axios.put(`/deep_performance/simple_report_detail/`, data, authHeaders(token));
  },
  async getReportDetail(token: string, project: number, report_id: number,) {
    return axios.get(`/report/report_detail/${report_id}/?project=${project}`, authHeaders(token));
  },
  async getReportSmgDetail(token: string, project: number, report_id: number,) {
    return axios.get(`/report/smg_ui_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getNewReportList(token: string, project: number,report_type?:any|null,create_date?:any|null,task_id?:any|null,subtype?:any|null) {
    if(create_date||task_id||subtype){
      return axios.get(`/report/report_list/?project=${project}&report_type=${report_type}&create_date=${create_date}&task_id=${task_id}&subtype=${subtype}`, authHeaders(token));
    }else{
      return axios.get(`/report/report_list/?project=${project}&report_type=${report_type}`, authHeaders(token))
    }

  },
  async getLiveReportList(token: string, project: number,) {

      return axios.get(`/report/live_report_list/?project=${project}`, authHeaders(token));


  },
  async deleteReport(token: string, project: number, report_id: number) {
    return axios.delete(`/report/report_detail/${report_id}/?project=${project}`, authHeaders(token));
  },
  async liveReport(token: string, project: number, report_id: number) {
    return axios.get(`/report/live_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getPerfReport(token: string, project: number, id: number, interval?: number | null,record_list?:any[]|null,old_record_list?:any[]|null,is_inside_skin?:any|null,report_type?:any) {
    if (interval) {
      return axios.get(`/report/perf_report_detail/?project=${project}&report_id=${id}&interval=${interval}`, authHeaders(token));
    } if(record_list||old_record_list){
      return axios.get(`/report/perf_report_detail/?project=${project}&report_id=${id}&record_list=${record_list}&old_record_list=${old_record_list}&is_inside_skin=${is_inside_skin}&is_inside_skin=${is_inside_skin}`, authHeaders(token));
    }if(report_type){
      return axios.get(`/report/perf_report_detail/?project=${project}&report_id=${id}&interval=${interval}&report_type=${report_type}`, authHeaders(token));
    }else {
      return axios.get(`/report/perf_report_detail/?project=${project}&report_id=${id}&is_inside_skin=${is_inside_skin}`, authHeaders(token));
    }

  },
  async getStressPerfReport(token: string, project: number, id: number, interval?: number | null,is_inside_skin?:any) {
    if (interval) {
      return axios.get(`/report/stress_report_detail/?project=${project}&report_id=${id}&interval=${interval}`, authHeaders(token));
    } else {
      return axios.get(`/report/stress_report_detail/?project=${project}&report_id=${id}&is_inside_skin=${is_inside_skin}`, authHeaders(token));
    }
  },
  async getPerfReportSpeedm(token: string, project: number, id: number) {
    return axios.get(`/report/speedm_report_detail/?project=${project}&report_id=${id}`, authHeaders(token));
  },
  async getPerfReportSpeedmGPU(token: string, project: number, id: number) {
    return axios.get(`/report/speedm_gpu_report/?project=${project}&report_id=${id}`, authHeaders(token));
  },
  async getNzmGpuReport(token: string, project: number, id: number) {
    return axios.get(`/report/nzm_gpu_report/?project=${project}&report_id=${id}`, authHeaders(token));
  },
  async uploadReportImage(token: string, data: IUploadReport) {
    return axios.post(`/report/perf_report_detail/`, data, authHeaders(token));
  },
  async uploadGamesReportImage(token: string, data: IUploadReport) {
    return axios.post(`/proj/games_subscription_date_list/`, data, authHeaders(token));
  },
  async uploadCpuReport1(token: string, data: IUploadCpuReport) {
    return axios.post(`/deep_performance/cpu_report/`, data, authHeaders(token));
  },
  async uploadPerfettoReport(token: string, data: IUploadCpuReport) {
    return axios.post(`/perfetto/perfetto_report/`, data, authHeaders(token));
  },
  async uploadXcodeReport(token: string, data: IUploadCpuReport) {
    return axios.post(`/xcode/perfetto_report/`, data, authHeaders(token));
  },
  async uploadCpuReport(token: string, data: IUploadCpuReport) {
    return axios.post(`/deep_performance/cpu_func_report/`, data, authHeaders(token));
  },
  async uploadPkgReport(token: string, data: IUploadCpuReport) {
    return axios.post(`/performance/pkg_resource_report/`, data, authHeaders(token));
  },
  async uploadNzmReportImage(token: string, data: INzmUploadReport) {
    return axios.post(`/deep_performance/simple_perfdata/`, data, authHeaders(token));
  },
  async uploadDcReportImage(token: string, data: IUploadDcReportSimple) {
    return axios.post(`/report/dc/`, data, authHeaders(token));
  },
  async uploadSpeedmReportImage(token: string, data: IUploadReport) {
    return axios.post(`/report/speedm_report_detail/`, data, authHeaders(token));
  },
  async uploadSpeedmReportImageGpu(token: string, data: IUploadReport) {
    return axios.post(`/report/speedm_gpu_report/`, data, authHeaders(token));
  },
  async aovCopyPerfToReport(token: string, project: number, task_record_id: any, device_id: any, report_id: any) {
    return axios.get(`/report/aov_copy_perf_to_report/?project=${project}&task_record_id=${task_record_id}&device_id=${device_id}&report_id=${report_id}`, authHeaders(token));
  },
  async getCODMReport(token: string, project: number, report_id: number) {
    return axios.get(`/report/codm_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async sendCODMReport(token: string, data: IUploadReport) {
    return axios.post(`/report/codm_report/`, data, authHeaders(token));
  },
  async getCODMReportList(token: string, project: number) {
    return axios.get(`/report/codm_reports/?project=${project}`, authHeaders(token));
  },
  async deleteCODMReport(token: string, id: number, project: number) {
    return axios.delete(`/report/codm_report_detail/${id}/?project=${project}`, authHeaders(token));
  },
  // 获取log
  async getLogContent(token: string, type: string, line: number) {
    return axios.get(`/log/log_content/?type=${type}&line=${line}`, authHeaders(token));
  },
  async getTOPReportList(token: string, project: number) {
    return axios.get<ITOPReport[]>(`/report/top_reports/?project=${project}`, authHeaders(token));
  },
  async getTOPReportDetail(token: string, project: number, id: number) {
    return axios.get<ITOPReport>(`/report/top_report_detail/${id}/?project=${project}`, authHeaders(token));
  },
  async getTOPReport(token: string, project: number, report_id: number) {
    return axios.get(`/report/top_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getTOPreportTable(token: string, project: number, sub_project: number,date:any,user:string){
    return axios.get(`/performance/all_performances/?project=${project}&sub_project=${sub_project}&date=${date}&user=${user}`, authHeaders(token));
  },
  async sendTOPReport(token: string, data: IUploadReportSimple) {
    return axios.post(`/report/top_report/`, data, authHeaders(token));
  },
  async updateTOPReport(token: string, data: ITOPReportUpload) {
    return axios.put(`/report/top_report_detail/${data.id}/`, data, authHeaders(token));

  },
  // table列表from过滤数据
  async getTOPReportTableList(token: string, project:number,) {
    return axios.get(`/performance/top_drop_list/?project=${project}`, authHeaders(token));
  },
  // 生成TOP报告
  async getTOPReportGenerate(token: string,data:any) {
    return axios.post(`/report/top_reports/`, data, authHeaders(token));
  },
  async deleteTOPReport(token: string, id: number, project: number) {
    return axios.delete(`/report/top_report_detail/${id}/?project=${project}`, authHeaders(token));
  },
  async deleteTokenList(token: string, id: number, project: number) {
    return axios.delete(`/peripheral_system/token/${id}/?project=${project}`, authHeaders(token));
  },
  // xHook报告
  async getXhookReportList(token: string,project: number) {
    return axios.get(`/report/xhook_reports/?project=${project}`, authHeaders(token));
  },
  async getXhookReport(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/xhook_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async sendXhookReport(token: string, data: IUploadReportSimple) {
    return axios.post(`/report/xhook_report/`, data, authHeaders(token));
  },
  async  deleteXhookReport(token: string,id: number, project: number) {
    return axios.get(`/report/xhook_report_detail/${id}/?project=${project}`, authHeaders(token));
  },
  // wado定制报告
  async getWedoReport(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/wedo_report_detail/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  // 王者皮肤测试局外定制报告
  async getSkinReport(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/skin_test_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getSmgReport(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/smg_level_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getSkinTableReport(token: string, project: number,report_id: number,type:string ) {
    return axios.get(`/report/skin/?project=${project}&report_id=${report_id}&type=${type}`, authHeaders(token));
  },
  async getArrange(token: string, data:{project: number,json_str: any,} ) {
    return axios.post(`/performance/perfdog_arrange/`,data, authHeaders(token));
  },
  async getArrangeByXlsx(token: string, data:IUploadskin) {
    return axios.post(`/performance/perfdog_arrange_by_xlsx/`,data, authHeaders(token));
  },
  async getSkinReportOption(token: string, project: number,task_record_id: any,skin_id:any ) {
    return axios.get(`/performance/skin_option/?project=${project}&task_record_id=${task_record_id}&skin_id=${skin_id}`, authHeaders(token));
  },
  async getSkinReportList(token: string, project: number,task_record_id: any, ) {
    return axios.get(`/performance/skin_list/?project=${project}&task_record_id=${task_record_id}`, authHeaders(token));
  },
  async getSkinReportOptionOld(token: string, project: number,) {
    return axios.get(`/performance/skin_option/?project=${project}`, authHeaders(token));
  },
  async getSkinReportWhole(token: string, project: number,task_record_id: any, game_version:any) {
    return axios.get(`/performance/skin_whole/?project=${project}&task_record_id=${task_record_id}&game_version=${game_version}`, authHeaders(token));
  },
  async getSkinReportdata(token: string, project: number,task_record_id: any,device_id:number|'',date:string,version:string,skin_id:any ) {
    return axios.get(`/performance/skin_data/?project=${project}&task_record_id=${task_record_id}&device_id=${device_id}&date=${date}&version=${version}&skin_id=${skin_id}`, authHeaders(token));
  },
  async getSkinReportComparedata(token: string, project: number,task_record_id: any,device_id:number|'',date:string,version:string ) {
    return axios.get(`/performance/skin_compare_data/?project=${project}&task_record_id=${task_record_id}&device_id=${device_id}&date=${date}&version=${version}`, authHeaders(token));
  },
  // 王者皮肤测试局内定制报告
  async getSkinReportInside(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/inside_skin_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  // 代号炽热皮肤测试报告
  async getSkinReportOsgame(token: string, project: number,report_id: number, ) {
    return axios.get(`/report/inside_skin_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  // 添加日志
  async getlogDownload(token: string, project: number,task_record_id: number,UUID:any, scene_id: number) {
    return axios.get(`/task/task_log/?project=${project}&task_record_id=${task_record_id}&UUID=${UUID}&scene_id=${scene_id}`, authHeaders(token));
  },
  // 冒烟测试报告
  async getSmokeReport(token: string, project: number,report_id: number|'',) {
    return axios.get(`/report/smoke_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getProtocolReport(token: string, project: number,report_id: number|'',) {
    return axios.get(`/report/protocol_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getLoginSmokeReport(token: string, project: number,report_id: number|'',) {
    return axios.get(`/report/login_smoke_report/?project=${project}&report_id=${report_id}`, authHeaders(token));
  },
  async getSmokeReportList(token: string, project: number) {
    return axios.get(`/report/smoke_reports/?project=${project}`, authHeaders(token));
  },
  async getProtocolList(token: string, project: number) {
    return axios.get(`/report/protocol_reports/?project=${project}`, authHeaders(token));
  },
  async getLoginSmokeReportList(token: string, project: number) {
    return axios.get(`/report/login_smokes/?project=${project}`, authHeaders(token));
  },
  async sendSmokeeport(token: string, data: IUploadSmokeReporrt) {
    return axios.post(`/report/smoke_report/`, data, authHeaders(token));
  },
  async sendProtocolReport(token: string, data: IUploadSmokeReporrt) {
    return axios.post(`/report/protocol_report/`, data, authHeaders(token));
  },
  async sendLoginSmokeport(token: string, data: IUploadSmokeReporrt) {
    return axios.post(`/report/login_smoke_report/`, data, authHeaders(token));
  },
  async deleteSmokeeport(token: string,report_id: number,project: number) {
    return axios.delete(`/report/smoke_report_detail/${report_id}/?project=${project}`, authHeaders(token));
  },
  async deleteProtocolReportDetail(token: string,report_id: number,project: number) {
    return axios.delete(`/report/protocol_report_detail/${report_id}/?project=${project}`, authHeaders(token));
  },
  async deleteLoginSmokeport(token: string,report_id: number,project: number) {
    return axios.delete(`/report/login_report_detail/${report_id}/?project=${project}`, authHeaders(token));
  },

  async getLabelReport(token: string, project: number, id: number, interval?: number | null,is_inside_skin?:any) {
    if (interval) {
      return axios.get(`/report/label_report_detail/?project=${project}&report_id=${id}&interval=${interval}`, authHeaders(token));
    } else {
      return axios.get(`/report/label_report_detail/?project=${project}&report_id=${id}&is_inside_skin=${is_inside_skin}`, authHeaders(token));
    }
  },
  async getPerformanceVersion(token: string, project: number,version:string,timestamp:string|"") {
    return axios.get(`/performance/project_scene_by_version/?project=${project}&version=${version}&timestamp=${timestamp}`, authHeaders(token));
  },
  // 清楚缓存
  async clearCache(token: string, report_id:number,project: number) {
    return axios.get(`/report/report_cache_clear/?report_id=${report_id}&project=${project}`, authHeaders(token));
  },
  async getDc(token: string,project: number,cur_version:any,test_time?:any,base_version?:any) {
    return axios.get(`/report/dc/?project=${project}&cur_version=${cur_version}&test_time=${test_time}&base_version=${base_version}`, authHeaders(token));
  },
  async getDcReport(token: string,project: number,is_base:number) {
    return axios.get(`/report/dc_list/?project=${project}&is_base=${is_base}`, authHeaders(token));
  },
  // 深度测试
  async getDeepPerformanceSelectOptions(token: string,  project: number,date?:any, game_version?:any,type?:number) {
    if(date){
      return axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}&date=${date}&game_version=${game_version}`, authHeaders(token));
    }
    if(type){
      return axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}&type=${type}`, authHeaders(token));
    }
    else{
      return  axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}`, authHeaders(token));
    }

  },
  async getDeepPerformanceSelectOptionsOld(token: string, project: number,date?:any, game_version?:any) {
    if(date){
      return axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}&date=${date}&game_version=${game_version}`, authHeaders(token));
    }else{
      return axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}`, authHeaders(token));
    }


  },
  async getDeepPerformanceSelectOptionsLast(token: string, project: number,date:any, game_version:any) {
    return axios.get<IDeepPerformanceSelectOptions>(`/performance/deep_performance_options/?project=${project}&date=${date}&game_version=${game_version}`, authHeaders(token));
  },
  async getDeepPerformancePageList(token: string, project: number,type?:number, scene_id_list?: number[] | [], device_id_list?: number[] | [], game_versions?: string[] | [], page?: number | "", size?: number | string,) {

    if(type){
      return axios.get<IPerDeepformanceCom>(`/performance/deep_performance_list/?project=${project}&type=${type}&scene_id=${scene_id_list}&device_id=${device_id_list}&game_versions=${game_versions}&page=${page}&size=${size}`, authHeaders(token));
    }else{
      return   axios.get<IPerDeepformanceCom>(`/performance/deep_performance_list/?project=${project}&scene_id=${scene_id_list}&device_id=${device_id_list}&game_versions=${game_versions}&page=${page}&size=${size}`, authHeaders(token))
    }



  },
  async getDeepPerformanceDetails(token: string, project: number, id_test: number) {
    return axios.get(`/performance/deep_performance_trend/?project=${project}&id_test=${id_test}`, authHeaders(token));
  },
  async getCaseMonitorList(token: string, project: number,) {
    return axios.get(`/testcase/case_monitor_list/?project=${project}`, authHeaders(token));
  },
  async getCaseMonitor(token: string, project: number,id:number|'') {
    return axios.get(`/testcase/case_monitor/?project=${project}&id=${id}`, authHeaders(token));
  },
  async getDeepPerformanceStack(token: string, project: number, id_test: number,frame:any|'',level:any|'',func_hash:any|'') {
    return axios.get(`/performance/deep_performance_stack/?project=${project}&id_test=${id_test}&frame=${frame}&level=${level}&func_hash=${func_hash}`, authHeaders(token));
  },
  async getNzmMemoryStack(token: string, project: number, type: string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,depth?:number|0,name?:any,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null) {
    if(version||scene||device||inside_scene||depth||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_stack/?project=${project}&type=${type}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&depth=${depth}&name=${name}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}`, authHeaders(token));
    }else{
      return axios.get(`/performance/nzm_memory_stack/?project=${project}&type=${type}`, authHeaders(token));
    }

  },
  async getNzmMemoryStackAll(token: string, project: number, type: string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,depth?:number|0,name?:any,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null) {
    if(version||scene||device||inside_scene||depth||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_stack_all/?project=${project}&type=${type}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&depth=${depth}&name=${name}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}`, authHeaders(token));
    }else{
      return axios.get(`/performance/nzm_memory_stack_all/?project=${project}&type=${type}`, authHeaders(token));
    }

  },
  // 预实例化
  async getInstantiation(token: string, project: number, id_test: any) {
    return axios.get(`/performance/pre_instantiation/?project=${project}&id_test=${id_test}`, authHeaders(token));
  },
  async getInstantiations(token: string, project: number,) {
    return axios.get(`/performance/pre_instantiations/?project=${project}`, authHeaders(token));
  },
  async deleteInstantiation(token: string, id_test: number, project: number) {
    return axios.delete(`/performance/pre_instantiation/?project=${project}&id_test=${id_test}`, authHeaders(token));
  },
  async ChangeFPS(token: string, project: number,id_test:number,value:number,labels:any,mode:any) {
    return axios.get(`/performance/fps_compute/?project=${project}&id_test=${id_test}&value=${value}&labels=${labels}&mode=${mode}`, authHeaders(token));
  },
  async getPlayerid(token: string, project: number,playerid_dst:number,playerid_src:number,) {
    return axios.get(`/common/dispatch/?project=${project}&playerid_dst=${playerid_dst}&playerid_src=${playerid_src}`, authHeaders(token));
  },
  async pipeline(token: string, project: number,pipeline_id:string,) {
    return axios.get(`/pipeline/pipeline_check/?project=${project}&pipeline_id=${pipeline_id}`, authHeaders(token));
  },
  async getTaskList(token: string, project: number,) {
    return axios.get(`/task/task_list/?project=${project}`, authHeaders(token));
  },
  // DC统计
  // async getDC(token: string, project: number,cur_version:any,test_time?:any,base_version?:any) {
  //   return axios.get(`/report/dc/?project=${project}&cur_version=${cur_version}&test_time=${test_time}&base_version=${base_version}`, authHeaders(token));
  // },
  // 深度性能内存专项数据
  async deepScene(token: string, project: number,type:string,version?:string|null,scene?:any,device?:any,old_version?:string|null,old_scene?:any,old_device?:any,) {

      return axios.get(`/performance/nzm_memory_options/?project=${project}&type=${type}&version=${version}&scene=${scene}&device=${device}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}`, authHeaders(token));


  },
  async deepMemreport(token: string, project: number,version:string,device:string,scene:number) {

      return axios.get(`/performance/nzm_memreport/?project=${project}&version=${version}&device=${device}&scene=${scene}`, authHeaders(token));


  },
  async deepSceneOptions(token: string, project: number,) {

      return axios.get(`/performance/nzm_memreport_options/?project=${project}`, authHeaders(token));


  },
  async deepMemoryOptions(token: string, project: number,) {

      return axios.get(`/memory/device_options/?project=${project}`, authHeaders(token));


  },
  async deepMemoryLlmList(token: string, project: number,) {

      return axios.get(`/memory/memreport_llm_list/?project=${project}`, authHeaders(token));


  },
  async deepMemoryDateOptions(token: string, project: number,) {

      return axios.get(`/memory/version_by_date_options/?project=${project}`, authHeaders(token));


  },
  async deepMemorySubSceneOptions(token: string, project: number,type:string) {

      return axios.get(`/memory/sub_scene_options/?project=${project}&type=${type}`, authHeaders(token));


  },
  async deepMemoryRecordList(token: string, project: number,date_version:any,device_id:any,scene_id:any,sub_scene:any,size:number,page:number,type:string) {

      return axios.get(`/memory/test_record_list/?project=${project}&date_version=${date_version}&device_id=${device_id}&scene_id=${scene_id}&sub_scene=${sub_scene}&size=${size}&page=${page}&type=${type}`, authHeaders(token));


  },
  async deepMemoryTrend(token: string, project: number,device_id:number,scene_id:number,type:string,start:string,end:string) {

      return axios.get(`/memory/memory_trend/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&type=${type}&start=${start}&end=${end}`, authHeaders(token));


  },
  async deepMemorySceneOptions(token: string, project: number,device_id:any) {

      return axios.get(`/memory/scene_options/?project=${project}&device_id=${device_id}`, authHeaders(token));


  },
  async deepMemoryDownLoad(token: string, project: number,id_test:number,old_test:number) {

      return axios.get(`/performance/memreport_download/?project=${project}&id_test=${id_test}&old_test=${old_test}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );


  },
  async deepTopDownLoad(token: string, project: number|'', label: string, model: string, level: number|'', tester: string,project_name,id_list?:any,id_test?:any,label_main?:any) {
    if(id_list){
      return axios.get(`/performance/top_download/?project=${project}&label=${encodeURIComponent(label)}&model=${model}&level=${level}&tester=${tester}&project_name=${project_name}&id_list=${id_list}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );
    }else{
      return axios.get(`/performance/top_download/?project=${project}&label=${encodeURIComponent(label)}&model=${model}&level=${level}&tester=${tester}&project_name=${project_name}&id_test=${id_test}&label_main=${label_main}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );
    }

  },
  async deepMemoryReport(token: string, project: number,task_record_id:number,version:string) {
      return axios.get(`/memory/memory_report/?project=${project}&task_record_id=${task_record_id}&version=${version}`, authHeaders(token));
  },
  async deepUnityMemoryReport(token: string, project: number,task_record_id:number,version:string) {

      return axios.get(`/memory/unity_memory_report/?project=${project}&task_record_id=${task_record_id}&version=${version}`, authHeaders(token));


  },
  async deepMemoryCircleChart(token: string, project: number,date:string,device_id:number,scene_id:number,sub_scene:string,version:string,old_date:string,old_device_id:number,old_scene_id:number,old_sub_scene:string,old_version:string,type:string) {

      return axios.get(`/memory/circle_chart/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&sub_scene=${sub_scene}&version=${version}&old_date=${old_date}&old_device_id=${old_device_id}&old_sub_scene=${old_sub_scene}&old_version=${old_version}&old_scene_id=${old_scene_id}&type=${type}`, authHeaders(token));


  },
  async deepMemoryUobject(token: string, project: number,date:string,device_id:number,scene_id:number,sub_scene:string,version:string,old_date:string,old_device_id:number,old_scene_id:number,old_sub_scene:string,old_version:string,) {

      return axios.get(`/memory/uobject/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&sub_scene=${sub_scene}&version=${version}&old_date=${old_date}&old_device_id=${old_device_id}&old_sub_scene=${old_sub_scene}&old_version=${old_version}&old_scene_id=${old_scene_id}`, authHeaders(token));


  },
  async deepMemoryUobjectTrend(token: string, project: number,device_id:number,scene_id:number) {

      return axios.get(`/memory/uobjects_trend/?project=${project}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));


  },
  async ObjectMemoryDate(token: string, project: number,) {

      return axios.get(`/object_memory/date_option/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryVersion(token: string, project: number,) {

      return axios.get(`/object_memory/version_option/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryDevice(token: string, project: number,) {

      return axios.get(`/object_memory/device_option/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryDeviceSecond(token: string, project: number,report_type:any,date:any,version:any) {

      return axios.get(`/object_memory/device_option/?project=${project}&report_type=${report_type}&date=${date}&version=${version}`, authHeaders(token));


  },
  async ObjectMemoryScene(token: string, project: number,) {

      return axios.get(`/object_memory/scene_option/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryType(token: string, project: number,) {

      return axios.get(`/object_memory/type_option/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryDateVersion(token: string, project: number,report_type?:any,device_id?:any) {
    if(report_type){
      return axios.get(`/object_memory/date_version_option/?project=${project}&report_type=${report_type}`, authHeaders(token));
    }
    else {
      return axios.get(`/object_memory/date_version_option/?project=${project}`, authHeaders(token));
    }



  },
  async ObjectMemoryDateVersionDevice(token: string, project: number,device_id?:any) {
    if(device_id){
      return axios.get(`/object_memory/date_version_option/?project=${project}&device_id=${device_id}`, authHeaders(token));
    }



  },
  async ObjectMemoryLevel(token: string, project: number,report_type:any,date:any,version:any,device_id:any) {

      return axios.get(`/object_memory/level_option/?project=${project}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));


  },
  async ObjectMemorySceneSecond(token: string, project: number,report_type:any,date:any,version:any,device_id:any) {

      return axios.get(`/object_memory/scene_option/?project=${project}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));


  },
  async ObjectMemorymoduleAll(token: string, project: number,report_type:any,date:any,version:any,device_id:any,scene_name:any,level:any,top:any,search:any,old_date:any,old_version:any,order_by:any,reverse:any) {

      return axios.get(`/object_memory/module_all/?project=${project}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}&scene_name=${scene_name}&level=${level}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}`, authHeaders(token));


  },
  async ObjectMemoryTrend(token: string, project: number,report_type:any,level:any,start:any,end:any) {

      return axios.get(`/object_memory/memory_trend/?project=${project}&report_type=${report_type}&level=${level}&start=${start}&end=${end}`, authHeaders(token));


  },
  async ObjectFunctionTrend(token: string, project: number,report_type:any,level:any,start:any,end:any,scene_name:any,device_id:any,date:any,version:any) {

      return axios.get(`/object_memory/func_list/?project=${project}&report_type=${report_type}&level=${level}&start=${start}&end=${end}&scene_name=${scene_name}&device_id=${device_id}&date=${date}&version=${version}`, authHeaders(token));


  },
  async ObjectFunctionId(token: string, project: number,id:any) {

      return axios.get(`/object_memory/func_list/?project=${project}&id=${id}`, authHeaders(token));


  },
  async ObjectMemoryModuleListId(token: string, project: number,id:any) {

    return axios.get(`/object_memory/module_list/?project=${project}&id=${id}`, authHeaders(token));


},
  async ObjectMemoryFileName(token: string, project: number,id:any) {

    return axios.get(`/object_memory/filename/?project=${project}&id=${id}`, authHeaders(token));


},
  async ObjectMemoryDownLoad(token: string, project: number,id:any,old_id:any,func:any,module:any) {

    return axios.get(`/object_memory/stack_download/?project=${project}&id=${id}&old_id=${old_id}&func=${func}&module=${module}`, authHeaders(token));


},
  async ObjectFunctionTrendDraw(token: string, project: number,report_type:any,level:any,start:any,end:any,scene_name:any,func_list:any) {

      return axios.get(`/object_memory/func_trend/?project=${project}&report_type=${report_type}&level=${level}&start=${start}&end=${end}&scene_name=${scene_name}&func_list=${func_list}`, authHeaders(token));


  },
  async ObjectMemoryReport(token: string, project: number,report_type:any,date:any,version:any,device_id:any) {

      return axios.get(`/object_memory/report/?project=${project}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));


  },
  async ObjectMemoryList(token: string, project: number,) {

      return axios.get(`/object_memory/module_list/?project=${project}`, authHeaders(token));


  },
  async ObjectMemoryListData(token: string, project: number,date_list:any) {

      return axios.get(`/object_memory/object_memory_list_v1/?project=${project}&date_list=${date_list}`, authHeaders(token));


  },
  async ObjectMemorStack(token: string, project: number,id:string,module:string,func:string,size:any) {

      return axios.get(`/object_memory/stack/?project=${project}&id=${id}&module=${module}&func=${encodeURIComponent(func)}&size=${size}`, authHeaders(token));


  },
  async ObjectMemorNoStack(token: string, project: number,module:string,func:string,size:any,date:any,version:any,device_id:any,report_type:any,scene_name:any,level:any) {

      return axios.get(`/object_memory/stack/?project=${project}&module=${module}&func=${encodeURIComponent(func)}&size=${size}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&level=${level}`, authHeaders(token));


  },
  async ObjectMemoryModuleList(token: string, project: number,start:string,end:string,device_id:string,scene_name:string) {

      return axios.get(`/object_memory/module_list/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_name=${scene_name}`, authHeaders(token));


  },
  async ObjectMemoryModuleListSecond(token: string, project: number,start:string,end:string,device_id:string,scene_name:string,level:any,report_type:any) {

      return axios.get(`/object_memory/module_list/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_name=${scene_name}&level=${level}&report_type=${report_type}`, authHeaders(token));


  },

  async ObjectMemoryModuleTrend(token: string, project: number,start:string,end:string,device_id:string,scene_name:string,modules:string) {

      return axios.get(`/object_memory/memory_module_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_name=${scene_name}&modules=${modules}`, authHeaders(token));


  },
  async ObjectMemoryModuleSubTrend(token: string, project: number,start:string,end:string,device_id:string,scene_name:string,modules:string,report_type:any,level:any) {

      return axios.get(`/object_memory/memory_module_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_name=${scene_name}&modules=${modules}&report_type=${report_type}&level=${level}`, authHeaders(token));


  },
  async deepMemreportData(token: string, project: number,date:string,device_id:number,scene_id:number,sub_scene:string,version:string,old_date:string,old_device_id:number,old_scene_id:number,old_sub_scene:string,old_version:string,class_name:string,search:string,page:any,size:any,order:string) {

    return axios.get(`/memory/memreport_data/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&sub_scene=${sub_scene}&version=${version}&old_date=${old_date}&old_device_id=${old_device_id}&old_sub_scene=${old_sub_scene}&old_version=${old_version}&old_scene_id=${old_scene_id}&class_name=${class_name}&search=${search}&page=${page}&size=${size}&order=${order}`, authHeaders(token));


},
  async deepUnityMemoryList(token: string, project: number,old_test:number|'',id_test:number,page:number,size:number,search:string,reverse:number) {

      return axios.get(`/memory/unity_memory_list/?project=${project}&old_test=${old_test}&id_test=${id_test}&page=${page}&size=${size}&search=${search}&reverse=${reverse}`, authHeaders(token));


  },
  async deepMemoryData(token: string, project: number, type: string,date:string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,depth?:number|0,name?:any,old_date?:string,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null,filter?:string) {
    // if(version||scene||device||inside_scene||depth||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_stack_all/?project=${project}&type=${type}&date=${date}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&depth=${depth}&name=${name}&old_date=${old_date}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}&filter=${filter}`, authHeaders(token));


  },
  async deepMemoryStackDataCread(token: string, project: number, type: string,date:string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,depth?:number|0,old_date?:string,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null,name?:string) {
    // if(version||scene||device||inside_scene||depth||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_stack/?project=${project}&type=${type}&date=${date}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&depth=${depth}&old_date=${old_date}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}&name=${name}`, authHeaders(token));


  },
  async deepMemoryStackDataCreadOld(token: string, project: number, type: string,date:string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,depth?:number|0,old_date?:string,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null) {
    // if(version||scene||device||inside_scene||depth||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_stack/?project=${project}&type=${type}&date=${date}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&depth=${depth}&old_date=${old_date}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}`, authHeaders(token));


  },
  async deepSceneOld(token: string, project: number,type:string,version?:string|null,scene?:any,device?:any,old_version?:string|null,old_scene?:any,old_device?:any,) {

      return axios.get(`/performance/nzm_memory_options_v1/?project=${project}&type=${type}&version=${version}&scene=${scene}&device=${device}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}`, authHeaders(token));


  },
  async deepFined(token: string, project: number, type: string,version?:string|null,scene?:any,device?:any,inside_scene?:string|null,old_version?:string|null,old_scene?:any,old_device?:any,old_inside_scene?:string|null,name?:any,) {
    if(version||scene||device||inside_scene||name||old_version||old_scene||old_device||old_inside_scene){
      return axios.get(`/performance/nzm_memory_find/?project=${project}&type=${type}&version=${version}&scene=${scene}&device=${device}&inside_scene=${inside_scene}&old_version=${old_version}&old_scene=${old_scene}&old_device=${old_device}&old_inside_scene=${old_inside_scene}&name=${name}`, authHeaders(token));
    }else{
      return axios.get(`/performance/nzm_memory_find/?project=${project}&type=${type}`, authHeaders(token));
    }

  },
  // 皮肤管线
  async skinManagement(token: string, project: number) {
    return axios.get(`/report/skin_line_options/?project=${project}`, authHeaders(token));
},
  async sgameSkinOption(token: string, project: number) {
    return axios.get(`/proj/sgame_skin_option/?project=${project}`, authHeaders(token));
},
  async sgameSkinData(token: string, project: number,skin_tab_id:any) {
    return axios.get(`/report/batch_skin_data/?project=${project}&skin_tab_id=${skin_tab_id}`, authHeaders(token));
},
async sgameSkinTabList(token: string,  data:{project: number,tab_name:string,start_date:any,end_date:any,skin_list:any},) {
  return axios.post(`/report/skin_tab_list/`,data, authHeaders(token));
},
async sgameSkinTabListGet(token: string,  project: number) {
  return axios.get(`/report/skin_tab_list/?project=${project}`, authHeaders(token));
},
  async skinLineView(token: string, project: number,pkg:number|string,quality:string,type:number|string,date:number|string,mark:string) {
    return axios.get(`/report/skin_line_view/?project=${project}&pkg=${pkg}&quality=${quality}&type=${type}&date=${date}&mark=${mark}`, authHeaders(token));
},
async updateSkinLineView(token: string,data: ISkinDetail) {
  return axios.put(`/report/skin_line_detail/${data.id}/`,data,authHeaders(token));

},
async skinLineDate(token: string,project: number,) {
  return axios.get(`/report/skin_line_date_options/?project=${project}`,authHeaders(token));

},
async skinLinePkg(token: string,project: number,date:string) {
  return axios.get(`/report/skin_line_pkg_options/?project=${project}&date=${date}`,authHeaders(token));

},
// 编辑用例
async testCase(token: string,project: number,) {
  return axios.get(`/testcase/case/?project=${project}`,authHeaders(token));

},
async testCaseList(token: string,project: number,) {
  return axios.get(`/testcase/action_list/?project=${project}`,authHeaders(token));

},
async caseControl(token: string, data:IControl) {
  return axios.put(`/testcase/case_control/`, data, authHeaders(token));
},
async caseDetail(token: string, data:ICaseDetail) {
  return axios.put(`/testcase/case_detail/${data.id}/`, data, authHeaders(token));
},
async deepPerformanceCheck(token: string, data:IdeepDataCheck) {
  return axios.put(`/performance/deep_performance/${data.id}/`, data, authHeaders(token));
},
async deepPerformanceSummaryEdit(token: string, data:IdeepDataCheck) {
  return axios.put(`/performance//performance/${data.id}/`, data, authHeaders(token));
},
// simple
async simpleDateOptions(token: string,project: number,) {
  return axios.get(`/deep_performance/simple_date_options/?project=${project}`,authHeaders(token));

},
async simpleTypeOptions(token: string,project: number,date:string|'') {
  return axios.get(`/deep_performance/simple_type_options/?project=${project}&date=${date}`,authHeaders(token));

},
async simpleLabelOptions(token: string,project: number,id_test:Number) {
  return axios.get(`/deep_performance/simple_label_options/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async cpuFuncDeivces(token: string,project: number,device_id:any,scene_id:any,is_auto:any,type:any,subtype:any) {
  return axios.get(`/deep_performance/cpu_func_devices/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`,authHeaders(token));

},
async deepCpuTrend(token: string,project: number,device_id:any,scene_id:any,is_auto:any,type:any,subtype:any,id_test:any) {
  return axios.get(`/deep_performance/cpu_trend/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&is_auto=${is_auto}&type=${type}&subtype=${subtype}&id_test=${id_test}`,authHeaders(token));

},
async cpuFuncScenes(token: string,project: number,device_id:any,scene_id:any, is_auto:any,type:any,subtype:any) {
  return axios.get(`/deep_performance/cpu_func_scenes/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`,authHeaders(token));

},
async simpleUrl(token: string,project: number,id_test:Number) {
  return axios.get(`/deep_performance/pipeline_url/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async simpleDeviceOptions(token: string,project: number,date:string|'',report_type:number|string,subtype:number,scene_id:number) {
  return axios.get(`/deep_performance/simple_device_options/?project=${project}&date=${date}&report_type=${report_type}&subtype=${subtype}&scene_id=${scene_id}`,authHeaders(token));

},
async simpleSceneOptions(token: string,project: number,date:string|'',report_type:number|string,subtype:number) {
  return axios.get(`/deep_performance/simple_scene_options/?project=${project}&date=${date}&report_type=${report_type}&subtype=${subtype}`,authHeaders(token));

},
async simpleSubtypeOptions(token: string,project: number,date:string|'',report_type:number|string) {
  return axios.get(`/deep_performance/simple_subtype_options/?project=${project}&date=${date}&report_type=${report_type}`,authHeaders(token));

},
async simpleData(token: string,project: number,date:string|'',report_type:number|string,UUID:number|string,subtype:number,id_test:number|'',scene_id:number) {
  return axios.get(`/deep_performance/simple_perfdata/?project=${project}&date=${date}&report_type=${report_type}&UUID=${UUID}&subtype=${subtype}&id_test=${id_test}&scene_id=${scene_id}`,authHeaders(token));

},
async simpleByData(token: string,project: number,date:string|'',report_type:number|string,UUID:number|string,subtype:number|string) {
  return axios.get(`/deep_performance/simple_data_by_many/?project=${project}&date=${date}&report_type=${report_type}&UUID=${UUID}&subtype=${subtype}`,authHeaders(token));

},
async simpleReportOptions(token: string,project: number,date:string|'',report_type:number|string,UUID:number|string,subtype:number|string,scene_id:number) {
  return axios.get(`/deep_performance/simple_report_options/?project=${project}&date=${date}&report_type=${report_type}&UUID=${UUID}&subtype=${subtype}&scene_id=${scene_id}`,authHeaders(token));

},
async simpleVersionOptions(token: string,project: number,date:string|'',report_type:number|string,UUID:number|string,subtype:number|string,scene_id:number) {
  return axios.get(`/deep_performance/simple_version_options/?project=${project}&date=${date}&report_type=${report_type}&UUID=${UUID}&subtype=${subtype}&scene_id=${scene_id}`,authHeaders(token));

},
async processOptions(token: string,project: number,id_test:number,Label:string,tab:string) {
  return axios.get(`/deep_performance/simple_process_options/?project=${project}&id_test=${id_test}&Label=${Label}&tab=${tab}`,authHeaders(token));

},
async simpleLog(token: string,project: number,id_test:number,Label:string,old_test:string) {
  return axios.get(`/deep_performance/simple_log/?project=${project}&id_test=${id_test}&Label=${Label}&old_test=${old_test}`,authHeaders(token));

},
async threadOptions(token: string,project: number,id_test:number,Label:string,tab:string,process_name:string) {
  return axios.get(`/deep_performance/simple_thread_options/?project=${project}&id_test=${id_test}&Label=${Label}&tab=${tab}&process_name=${process_name}`,authHeaders(token));

},
async soOptions(token: string,project: number,id_test:number,Label:string,tab:string,process_name:string,thread_name:string) {
  return axios.get(`/deep_performance/simple_so_options/?project=${project}&id_test=${id_test}&Label=${Label}&tab=${tab}&process_name=${process_name}&thread_name=${thread_name}`,authHeaders(token));

},
async simpleVersionOptionsOld(token: string,project: number,date:string|'',) {
  return axios.get(`/deep_performance/simple_version_options/?project=${project}&date=${date}`,authHeaders(token));

},
async simpleTrendParams(token: string,project: number,id_test:number,Label:string,tab:string) {
  return axios.get(`/deep_performance/simple_trend_params/?project=${project}&id_test=${id_test}&Label=${Label}&tab=${tab}`,authHeaders(token));

},
async simpleTotalTrend(token: string,data:ISimpleTrend) {
  return axios.post(`/deep_performance/simple_total_trend/`,data,authHeaders(token));

},
async deleteSimpleData(token: string, id_test: number, project: number) {
  return axios.delete(`/deep_performance/simple_perfdate_detail/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deleteAbd(token: string, id_test: number, project: number) {
  return axios.delete(`/abd/clear/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deleteFile(token: string, id_test: number, project: number) {
  return axios.delete(`/performance_log/app_file_clear/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deleteLight(token: string, id_test: number, project: number) {
  return axios.delete(`/light_performance/clear/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deleteOffline(token: string, id_test: number, project: number) {
  return axios.delete(`/performance_log/offline_clear/?project=${project}&id_test=${id_test}`, authHeaders(token));
},

async sendMemory(token: string,data:IMemory) {
  return axios.post(`/memory/memory_report/`,data,authHeaders(token));

},
async simpleTaskOptions(token: string,project: number,) {
  return axios.get(`/deep_performance/simple_task_options/?project=${project}`,authHeaders(token));

},
async simpleTable(token: string,project: number,id_test:number,Label:string,old_test:number,page:number,tab:string,process_name:string,thread_name:string,so_name:string,size:number|string,search:string, is_null?:any) {
  return axios.get(`/deep_performance/simple_total/?project=${project}&id_test=${id_test}&Label=${Label}&old_test=${old_test}&page=${page}&tab=${tab}&process_name=${process_name}&thread_name=${thread_name}&so_name=${so_name}&size=${size}&search=${search}&is_null=${is_null}`,authHeaders(token));

},
// lightPerf

async lightPerfDate(token: string,project: number,data_type:string) {
  return axios.get(`/light_performance/date_options/?project=${project}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfDateContrast(token: string, project: number,device_id:number,scene_id:number,subtype:number,data_type:string) {
  return axios.get(`/light_performance/date_options/?project=${project}&scene_id=${scene_id}&device_id=${device_id}&subtype=${subtype}&data_type=${data_type}`, authHeaders(token));
},
async lightPerfResourceCost(token: string,project: number,id_test:number,date_list:any,data_type:string) {
  return axios.get(`/light_performance/resource_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfJankCost(token: string,project: number,id_test:number,date_list:any,data_type?:string) {
  if(data_type){
    return axios.get(`/light_performance/jank_cost_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}&data_type=${data_type}`,authHeaders(token));
  }else{
    return axios.get(`/light_performance/jank_cost_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}`,authHeaders(token));
  }


},
async lightPerfMethodCost(token: string,project: number,id_test:number,date_list:any,data_type?:string) {
  if(data_type){
    return axios.get(`/light_performance/method_cost_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}&data_type=${data_type}`,authHeaders(token));
  }else{
    return axios.get(`/light_performance/method_cost_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}`,authHeaders(token));
  }


},
async lightPerfTrend(token: string,project: number,id_test:number,functions:any,data_type:string) {
  return axios.get(`/light_performance/method_cost_trend/?project=${project}&id_test=${id_test}&functions=${functions}&data_type=${data_type}`,authHeaders(token));

},
async androidAppFileTrend(token: string,project: number,id_test:number,file_name:any) {
  return axios.get(`/performance_log/app_file_trend/?project=${project}&id_test=${id_test}&file_name=${file_name}`,authHeaders(token));

},
async lightPerfFunctions(token: string,project: number,id_test:number,  data_type:string) {
  return axios.get(`/light_performance/method_cost_functions/?project=${project}&id_test=${id_test}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfUrl(token: string,project: number,id_test:number) {
  return axios.get(`/light_performance/pipeline_url/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async androidAppFilename(token: string,project: number,id_test:number) {
  return axios.get(`/performance_log/app_filename/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async androidAppFileUrl(token: string,project: number,id_test:number) {
  return axios.get(`/performance_log/pipeline_url/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async lightPerfDevice(token: string,project: number,date:string,data_type:string) {
  return axios.get(`/light_performance/device_options/?project=${project}&date=${date}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfScene(token: string,project: number,date:string,device_id:number,data_type:string) {
  return axios.get(`/light_performance/scene_options/?project=${project}&date=${date}&device_id=${device_id}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfSubtype(token: string,project: number,date:string,device_id:number,scene_id:number,data_type:string) {
  return axios.get(`/light_performance/subtype_options/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfLog(token: string,project: number,date:string,device_id:number,scene_id:number,subtype:number,data_type:string) {
  return axios.get(`/light_performance/light_performances/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}&data_type=${data_type}`,authHeaders(token));

},
async lightPerfEditLog(token: string,data:EditLog) {
  return axios.post(`/light_performance/light_performances/`,data,authHeaders(token));

},
async lightResource(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number,data_type:string) {
  return axios.get(`/light_performance/resource/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}&data_type=${data_type}`, authHeaders(token));
},
async lightJank(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number,data_type?:string) {
  if(data_type){
    return axios.get(`/light_performance/jank_cost/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}&data_type=${data_type}`, authHeaders(token));
  }else{
    return axios.get(`/light_performance/jank_cost/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
  }

},
async lightMethod(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number,data_type?:string) {
  if(data_type){
    return axios.get(`/light_performance/method_cost/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}&data_type=${data_type}`, authHeaders(token));
  }else{
    return axios.get(`/light_performance/method_cost/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
  }

},
// 安卓APP文件
async androidAppDate(token: string,project: number,) {
  return axios.get(`/performance_log/date_options/?project=${project}`,authHeaders(token));

},
async androidAppDateContrast(token: string, project: number,device_id:number,scene_id:number,subtype:number) {
  return axios.get(`/performance_log/date_options/?project=${project}&scene_id=${scene_id}&device_id=${device_id}&subtype=${subtype}`, authHeaders(token));
},
async androidAppDevice(token: string,project: number,date:string) {
  return axios.get(`/performance_log/device_options/?project=${project}&date=${date}`,authHeaders(token));

},
async androidAppZip(token: string,project: number,id_test:number) {
  return axios.get(`/performance_log/app_zip/?project=${project}&id_test=${id_test}`,authHeaders(token));

},
async androidAppScene(token: string,project: number,date:string,device_id:number) {
  return axios.get(`/performance_log/scene_options/?project=${project}&date=${date}&device_id=${device_id}`,authHeaders(token));

},
async androidAppSubtype(token: string,project: number,date:string,device_id:number,scene_id:number) {
  return axios.get(`/performance_log/subtype_options/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}`,authHeaders(token));

},
async androidAppLog(token: string,project: number,date:string,device_id:number,scene_id:number,subtype:number) {
  return axios.get(`/performance_log/app_file_list/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`,authHeaders(token));

},
async androidAppFileData(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number) {
  return axios.get(`/performance_log/app_file_data/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
},
async androidAppFileCompare(token: string,project: number,id_test:number,date_list:any) {
  return axios.get(`/performance_log/app_file_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}`,authHeaders(token));

},
// cfm武器
async weaponDetail(token: string, project: number, report_id: number) {
  return axios.get(`report/weapon_report_detail/?project=${project}&report_id=${report_id}`, authHeaders(token));
},
// ADB
async abdDateOptions(token: string, project: number, ) {
  return axios.get(`/abd/abd_date_options/?project=${project}`, authHeaders(token));
},
async lightSmokeScenes(token: string, project: number, light_type:any) {
  return axios.get(`/report/light_smoke_scenes/?project=${project}&light_type=${light_type}`, authHeaders(token));
},
async lightSmokeVersions(token: string, project: number,light_type:any) {
  return axios.get(`/report/light_smoke_versions/?project=${project}&light_type=${light_type}`, authHeaders(token));
},
async lightCommonKey(token: string, data:{project: number,key:any}) {
  return axios.post(`/common/url/`,data, authHeaders(token));
},
async lightCommonUrl(token: string, data:{project: number,url:any}) {
  return axios.post(`/common/url/`,data, authHeaders(token));
},
async lightSmokeDevices(token: string, project: number, scene:string,light_type:any) {
  return axios.get(`/report/light_smoke_devices/?project=${project}&scene=${scene}&light_type=${light_type}`, authHeaders(token));
},
async lightSmokeTodDevices(token: string, project: number, scene:string,device:string,light_type:any) {
  return axios.get(`/report/light_tod_devices/?project=${project}&scene=${scene}&device=${device}&light_type=${light_type}`, authHeaders(token));
},
async lightSmokeList(token: string, project: number, scene:string,device:string,version_list:any,tod:any,test_result:any,problem_type:any,light_type:any,ai_check:any,version?:any,date?:any) {
  return axios.get(`/report/light_smoke_list/?project=${project}&scene=${scene}&device=${device}&version_list=${version_list}&tod=${tod}&test_result=${test_result}&problem_type=${problem_type}&light_type=${light_type}&ai_check=${ai_check}&version=${version}&date=${date}`, authHeaders(token));
},
async lightSmokeListExport(token: string, project: number, scene:string,device:string,version_list:any,tod:any) {
  return axios.get(`/report/light_smoke_export/?project=${project}&scene=${scene}&device=${device}&version_list=${version_list}&tod=${tod}`,{ headers: { 'Access-Token': token}, responseType: 'blob' } );
},
  async lightSmokeHtmltExport(token: string, project: number, scene:string,device:string,version_list:any,tod:any,only_no_pass:any,light_type:any,test_result:any,problem_type:any) {
    return axios.get(`/report/html_export/?project=${project}&scene=${scene}&device=${device}&version_list=${version_list}&tod=${tod}&only_no_pass=${only_no_pass}&light_type=${light_type}&test_result=${test_result}&problem_type=${problem_type}`,{ headers: { 'Access-Token': token, 'Content-Type': 'application/zip', }, responseType: 'blob' } );
  },
  async lightSmokeOLhtmlExport(token: string, project: number, scene:string,device:string,version_list:any,tod:any,only_no_pass:any,light_type:any,test_result:any,problem_type:any) {
    return axios.get(`/report/online_html_export/?project=${project}&scene=${scene}&device=${device}&version_list=${version_list}&tod=${tod}&only_no_pass=${only_no_pass}&light_type=${light_type}&test_result=${test_result}&problem_type=${problem_type}`,{ headers: { 'Access-Token': token, }, responseType: 'blob' } );
  },
async smokeByReport(token: string, project: number, page: number, size: number,start:string,end:string,search:string) {
  return axios.get(`/report/smoke_reports_by_page/?project=${project}&page=${page}&size=${size}&start=${start}&end=${end}&search=${search}`, authHeaders(token));
},
async smokeByReportPut(token: string, id:number,projecet:number,data:{remark:any}) {
  return axios.put(`/report/smoke_report_detail/${id}/?project=${projecet}`,data,authHeaders(token));
},
async EditspeedmMemoryList(token: string ,data: { project: number,  id: any,remark}) {
  return axios.put(`/memory/speedm_memory_list/`,data,authHeaders(token));
},
async abdDeviceptions(token: string, project: number,date:string|'' ) {
  return axios.get(`/abd/abd_device_options/?project=${project}&date=${date}`, authHeaders(token));
},
async abdSceneOptions(token: string, project: number, date:string|'',device_id:number|'') {
  return axios.get(`/abd/abd_scene_options/?project=${project}&date=${date}&device_id=${device_id}`, authHeaders(token));
},
async abdSubtypeOptions(token: string, project: number, date:string|'',device_id:number|'',scene_id:number|'') {
  return axios.get(`/abd/abd_subtype_options/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
},
async abdList(token: string, project: number, date:string|'',device_id:number|'',scene_id:number|'',subtype:number|'') {
  return axios.get(`/abd/abd_list/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`, authHeaders(token));
},
async abdDateSingle(token: string, project: number, scene_id:number|'',device_id:number|'',subtype:number|'') {
  return axios.get(`/abd/abd_date_options/?project=${project}&scene_id=${scene_id}&device_id=${device_id}&subtype=${subtype}`, authHeaders(token));
},
async abdCompare(token: string, project: number,id_test:number,date_list:any,scene_id:number|'',device_id:number|'',subtype:number|'') {
  return axios.get(`/abd/abd_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}&scene_id=${scene_id}&device_id=${device_id}&subtype=${subtype}`, authHeaders(token));
},
async abdProcessCompare(token: string, project: number,id_test:number,date_list:any,scene_id:number|'',device_id:number|'',subtype:number|'') {
  return axios.get(`/abd/abd_process_compare/?project=${project}&id_test=${id_test}&date_list=${date_list}&scene_id=${scene_id}&device_id=${device_id}&subtype=${subtype}`, authHeaders(token));
},
async abdSum(token: string, project: number,id_test:number,) {
  return axios.get(`/abd/abd_sum/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async abdLog(token: string, project: number,id_test:number,) {
  return axios.get(`/abd/abd_log/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async abdUrl(token: string, project: number,id_test:number,) {
  return axios.get(`/abd/pipeline_url/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async abdType(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number) {
  return axios.get(`/abd/abd_type/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
},
async abdprocess(token: string, project: number,id_test:number|'',search:string,size: number | string, page: number) {
  return axios.get(`/abd/abd_process/?project=${project}&id_test=${id_test}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
},
async memoryResouceSpeedOptions(token: string, project: number,) {
  return axios.get(`/memory/resource_speed_options/?project=${project}`, authHeaders(token));
},
async memoryResouceVehicle(token: string, project: number,Versions:any,ScanTime:any,RecordID:any,AssetType:any,AssetID:any,AssetSubType:any) {
  return axios.get(`/memory/resource_speed_vehicle/?project=${project}&Versions=${Versions}&ScanTime=${ScanTime}&RecordID=${RecordID}&AssetType=${AssetType}&AssetID=${AssetID}&AssetSubType=${AssetSubType}`, authHeaders(token));
},
// 包体资源
async pkgResourceDate(token: string, project: number,) {
  return axios.get(`/performance/pkg_resource_date/?project=${project}`, authHeaders(token));
},

async pkgResourceDevice(token: string, project: number,date:string) {
  return axios.get(`/performance/pkg_resource_devices/?project=${project}&date=${date}`, authHeaders(token));
},
async pkgResourceScenes(token: string, project: number,date:string,device_id:number) {
  return axios.get(`/performance/pkg_resource_scenes/?project=${project}&date=${date}&device_id=${device_id}`, authHeaders(token));
},
async pkgResourceList(token: string, project: number,date?:string,) {
  if(date){
    return axios.get(`/performance/pkg_resource_list/?project=${project}&date=${date}`, authHeaders(token));
  }else{
    return axios.get(`/performance/pkg_resource_list/?project=${project}`, authHeaders(token));
  }

},
async pkgResourceReport(token: string, project: number,id_test:number,old_test:number) {

    return axios.get(`/performance/pkg_resource_report/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));


},
async pkgResourceAbnormalList(token: string, project: number,id_test:number,page:any,size:any,search:any,type:any,is_ignore:any) {

    return axios.get(`/performance/abnormal_resource_list/?project=${project}&id_test=${id_test}&page=${page}&size=${size}&search=${search}&type=${type}&is_ignore=${is_ignore}`, authHeaders(token));


},
async pkgResourceAbnormalFile(token: string, project: number,id_test:number,type:any,is_ignore:any) {

    return axios.get(`/performance/abnormal_resource_file/?project=${project}&id_test=${id_test}&type=${type}&is_ignore=${is_ignore}`, authHeaders(token));


},
async pkgResourceList1(token: string, project: number,date:string,) {
  return axios.get(`/performance/pkg_resource_list/?project=${project}&date=${date}`, authHeaders(token));
},
async pkgResourceStack(token: string, project: number,id_test:number,id_row?:number|string,depth?:number|string) {
 if(id_row){
  return axios.get(`/performance/pkg_resource_stack_v1/?project=${project}&id_test=${id_test}&id_row=${id_row}&depth=${depth}`, authHeaders(token));
 }else{
  return axios.get(`/performance/pkg_resource_stack_v1/?project=${project}&id_test=${id_test}`, authHeaders(token));
 }
},
async pkgResourceStackOld(token: string, project: number,id_test:number,id_row?:number|string,depth?:number|string) {
  if(id_row){
   return axios.get(`/performance/pkg_resource_stack_v1/?project=${project}&id_test=${id_test}&id_row=${id_row}&depth=${depth}`, authHeaders(token));
  }else{
   return axios.get(`/performance/pkg_resource_stack_v1/?project=${project}&id_test=${id_test}`, authHeaders(token));
  }
 },
async pkgTypeList(token: string, project: number,id_test:number,search:string,page:number,size:number) {
  return axios.get(`/performance/pkg_type_list/?project=${project}&id_test=${id_test}&search=${search}&page=${page}&size=${size}`, authHeaders(token));
},
async pkgTypeRate(token: string, project: number,id_test:number,) {
  return axios.get(`/performance/pkg_type_rate/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async pkgAssetStack(token: string, project: number,id_test:number,is_ignore:any,filename:any,page:any,size:any) {
  return axios.get(`/performance/pkg_asset_stack/?project=${project}&id_test=${id_test}&is_ignore=${is_ignore}&filename=${filename}&page=${page}&size=${size}`, authHeaders(token));
},
async pkgAssetType(token: string, project: number,id_test:number) {
  return axios.get(`/performance/pkg_asset_type/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async pkgStructStack(token: string, project: number,id_test:number,) {
  return axios.get(`/performance/pkg_struct_stack/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async speedmMemoryFilenameList(token: string, project: number,id_test:number,) {
  return axios.get(`/memory/filename_list/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async speedmMemorySourceList(token: string, project: number,id_test:any,) {
  return axios.get(`/memory/mod_source_files/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async speedmMemorySourceFilesList(token: string, project: number,id_test:number,page:any,size:any,filename:any,param:any,reverse:any) {
  return axios.get(`/memory/mod_source_list/?project=${project}&id_test=${id_test}&page=${page}&size=${size}&filename=${filename}&param=${param}&reverse=${reverse}`, authHeaders(token));
},
async speedmMemoryModSummary(token: string, project: number,id_test:any,old_test:any) {
  return axios.get(`/memory/mod_summary/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));
},
async speedmMemoryModSummaryV1(token: string, project: number,id_test:any,old_test:any,order_by:any,reverse:any) {
  return axios.get(`/memory/mod_res_summary_list_v1/?project=${project}&id_test=${id_test}&old_test=${old_test}&order_by=${order_by}&reverse=${reverse}`, authHeaders(token));
},
async speedmMemoryList(token: string, project: number,scene_name:any,device_id:any) {
  return axios.get(`/memory/speedm_memory_list/?project=${project}&scene_name=${scene_name}&device_id=${device_id}`, authHeaders(token));
},
async speedmMemoryConfig(token: string, project: number,key:any) {
  return axios.get(`/memory/memory_config/?project=${project}&key=${key}`, authHeaders(token));
},
async speedMemSummartList(token: string, project: number,scene_name:any,device_id:any,start:any,end:any,compare:any,by:any, page?: any) {
  return axios.get(`/memory/mem_summary_list/?project=${project}&scene_name=${scene_name}&device_id=${device_id}&start=${start}&end=${end}&compare=${compare}&by=${by}&page=${page ? page : ''}`, authHeaders(token));
},
async speedMemSummaryTrend(token: string, project: number,scene_name:any,name:any,device_type:any) {
  return axios.get(`/memory/mem_summary_trend/?project=${project}&scene_name=${scene_name}&name=${name}&device_type=${device_type}`, authHeaders(token));
},
async speedMemDateVersions(token: string, project: number,scene_name:any,) {
  return axios.get(`/memory/date_versions/?project=${project}&scene_name=${scene_name}`, authHeaders(token));
},
async speedMemSummartListV1(token: string, project: number,id_test:any,old_test:any) {
  return axios.get(`/memory/mem_summary_list_v1/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));
},
async speedmMemoryScens(token: string, project: number,record_id:any,date:any) {
  return axios.get(`/memory/speedm_memory_versions/?project=${project}&record_id=${record_id}&date=${date}`, authHeaders(token));
},
async speedmMemoryRecords(token: string, project: number,date:any) {
  return axios.get(`/memory/speedm_memory_records/?project=${project}&date=${date}`, authHeaders(token));
},
async speedmMemoryDates(token: string, project: number,) {
  return axios.get(`/memory/speedm_memory_dates/?project=${project}`, authHeaders(token));
},
async speedmResourceConfig(token: string, project: number,) {
  return axios.get(`/memory/resource_config/?project=${project}`, authHeaders(token));
},
async speedmMemoryDevices(token: string, project: number,version:any,record_id:any,date:any) {
  return axios.get(`/memory/speedm_memory_devices/?project=${project}&version=${version}&record_id=${record_id}&date=${date}`, authHeaders(token));
},
async speedmHistoryMemoryDevices(token: string, project: number,) {
  return axios.get(`/memory/speedm_memory_devices/?project=${project}`, authHeaders(token));
},
async speedmResourceScanDates(token: string, project: number,) {
  return axios.get(`/memory/resource_scan_dates/?project=${project}`, authHeaders(token));
},
async speedmResourceOverall(token: string, project: number,front:any,behind:any) {
  return axios.get(`/memory/resource_scan_overall/?project=${project}&front=${front}&behind=${behind}`, authHeaders(token));
},
async speedmResourceScanAverageData(token: string, project: number) {
  return axios.get(`/memory/resource_scan_average_data/?project=${project}`, authHeaders(token));
},
async speedmResourceScanChart(token: string, project: number,scan_type:any,car_name:any) {
  return axios.get(`/memory/resource_scan_chart/?project=${project}&scan_type=${scan_type}&car_name=${car_name}`, authHeaders(token));
},
async speedmResourceHistory(token: string, project: number,car_name:any) {
  return axios.get(`/memory/resource_scan_chart_history/?project=${project}&car_name=${car_name}`, authHeaders(token));
},
async speedmResourceScanChartAvg(token: string, project: number,scan_type:any,car_name:any) {
  return axios.get(`/memory/resource_scan_chart_avg/?project=${project}&scan_type=${scan_type}&car_name=${car_name}`, authHeaders(token));
},
async speedmResourceScanTypeList(token: string, project: number) {
  return axios.get(`/memory/resource_scan_type_list/?project=${project}`, authHeaders(token));
},
async speedmResourceScanLoadList(token: string, project: number,car_name:any,id_test:any,scan_type:any) {
  return axios.get(`/memory/resource_scan_lod_list/?project=${project}&id_test=${id_test}&car_name=${car_name}&scan_type=${scan_type}`, authHeaders(token));
},
async speedmResourceScanSkinList(token: string, project: number,car_name:any,id_test:any,scan_type:any,lod_name:any) {
  return axios.get(`/memory/resource_scan_skin_list/?project=${project}&car_name=${car_name}&id_test=${id_test}&scan_type=${scan_type}&lod_name=${lod_name}`, authHeaders(token));
},
async speedmResourceScanCarList(token: string, project: number,id_test:any,scan_type:any) {
  return axios.get(`/memory/resource_scan_car_list/?project=${project}&id_test=${id_test}&scan_type=${scan_type}`, authHeaders(token));
},
async speedmResourceScanCarData(token: string, project: number,id_test:any,car_name:any,page:any,size:any,scan_type:any,lod_name:any,skin_name:any) {
  return axios.get(`/memory/resource_scan_car_data/?project=${project}&id_test=${id_test}&car_name=${car_name}&page=${page}&size=${size}&scan_type=${scan_type}&lod_name=${lod_name}&skin_name=${skin_name}`, authHeaders(token));
},
async speedmResourceScanRecords(token: string, project: number,date:string) {
  return axios.get(`/memory/resource_scan_records/?project=${project}&date=${date}`, authHeaders(token));
},
async speedmResourceScanVersions(token: string, project: number,date:string,record_id:any) {
  return axios.get(`/memory/resource_scan_versions/?project=${project}&date=${date}&record_id=${record_id}`, authHeaders(token));
},
async speedmResourceScanDevices(token: string, project: number,date:string,record_id:any,version:any) {
  return axios.get(`/memory/resource_scan_devices/?project=${project}&date=${date}&record_id=${record_id}&version=${version}`, authHeaders(token));
},
async speedmResourceScanScenes(token: string, project: number,date:string,record_id:any,version:any,device_name:any) {
  return axios.get(`/memory/resource_scan_scenes/?project=${project}&date=${date}&record_id=${record_id}&version=${version}&device_name=${device_name}`, authHeaders(token));
},
async speedmResourceScanId(token: string, project: number,date:string,record_id:any,version:any,device_name:any,scene_name:any) {
  return axios.get(`/memory/resource_scan_id/?project=${project}&date=${date}&record_id=${record_id}&version=${version}&device_name=${device_name}&scene_name=${scene_name}`, authHeaders(token));
},
async speedmMemoryScenes(token: string, project: number,version:any,record_id:any,device_id:any,date:any, is_remark?:any) {
  return axios.get(`/memory/speedm_memory_scenes/?project=${project}&version=${version}&record_id=${record_id}&device_id=${device_id}&date=${date}`, authHeaders(token));
},
async speedmHistoryMemoryScenes(token: string, project: number,device_id:any, is_remark ?: any) {
  return axios.get(`/memory/speedm_memory_scenes/?project=${project}&device_id=${device_id}&is_remark=${is_remark}`, authHeaders(token));
},
async speedmMemoryId(token: string, project: number,version:any,record_id:any,device_id:any,scene_name:any,date:any) {
  return axios.get(`/memory/speedm_memory_id/?project=${project}&version=${version}&record_id=${record_id}&device_id=${device_id}&scene_name=${scene_name}&date=${date}`, authHeaders(token));
},
async speedmModList(token: string, project: number,device_id:any,scene_name:any,start:any,end:any,compare:any,by:any, page?:any) {
  return axios.get(`/memory/mod_summary_list/?project=${project}&device_id=${device_id}&scene_name=${scene_name}&start=${start}&end=${end}&compare=${compare}&by=${by}&page=${page ? page : ''}`, authHeaders(token));
},
async speedmExport(token: string, project: number,device_id:any,scene_name:any,start:any,end:any) {
  return axios.get(`/memory/speedm_memory_export/?project=${project}&device_id=${device_id}&scene_name=${scene_name}&start=${start}&end=${end}`,   { headers: { 'Access-Token': token}, responseType: 'blob' });
},
async batchSkinExport(token: string, project: number,skin_tab_id:any,) {
  return axios.get(`/report/batch_skin_export/?project=${project}&skin_tab_id=${skin_tab_id}`,   { headers: { 'Access-Token': token}, responseType: 'blob' });
},
async speedmModResList(token: string, project: number,device_id:any,scene_name:any,start:any,end:any,compare:any,by:any, page?:any) {
  return axios.get(`/memory/mod_res_summary_list/?project=${project}&device_id=${device_id}&scene_name=${scene_name}&start=${start}&end=${end}&compare=${compare}&by=${by}&page=${page ? page : ''}`, authHeaders(token));
},
async speedmMemoryResSummary(token: string, project: number,id_test:any,old_test:any,filename:any) {
  return axios.get(`/memory/res_summary/?project=${project}&id_test=${id_test}&old_test=${old_test}&filename=${filename}`, authHeaders(token));
},
async speedmMemoryResTrend(token: string, project: number,filename:any,scene_name:any) {
  return axios.get(`/memory/speedm_memory_trend/?project=${project}&filename=${filename}&scene_name=${scene_name}`, authHeaders(token));
},
async speedmResSummaryList(token: string, project: number,filename:any,scene_name:any,device:any) {
  return axios.get(`/memory/res_summary_list/?project=${project}&filename=${filename}&scene_name=${scene_name}&device=${device}`, authHeaders(token));
},
async speedmModTrend(token: string, project: number,scene_name:any) {
  return axios.get(`/memory/mod_summary_trend/?project=${project}&scene_name=${scene_name}`, authHeaders(token));
},
async pkgMapStructStack(token: string, project: number,id_test:number,filename:string) {
  return axios.get(`/performance/pkg_map_struct/?project=${project}&id_test=${id_test}&filename=${filename}`, authHeaders(token));
},
async pkgMapStructStackList(token: string, project: number,id_test:number,filename:string) {
  return axios.get(`/performance/map_struct_list/?project=${project}&id_test=${id_test}&filename=${filename}`, authHeaders(token));
},
async pkgMapStructStackOption(token: string, project: number,id_test:number,) {
  return axios.get(`/performance/map_struct_option/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async pkgAssetStackFind(token: string, project: number,id_test:number,name:string) {
  return axios.get(`/performance/pkg_asset_find/?project=${project}&id_test=${id_test}&name=${name}`, authHeaders(token));
},
async pkgResourceSum(token: string, project: number,id_test:number) {
  return axios.get(`/performance/pkg_resource_sum/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async pkgResourceTrend(token: string, project: number,id_test:number,names:any,id_row:any,start:any,end:any) {
  return axios.get(`/performance/pkg_resource_trend/?project=${project}&id_test=${id_test}&names=${names}&id_row=${id_row}&start=${start}&end=${end}`, authHeaders(token));
},
async pkgAssetTrend(token: string, project: number,start:any,end:any) {
  return axios.get(`/performance/pkg_asset_trend/?project=${project}&start=${start}&end=${end}`, authHeaders(token));
},
async pkgStructTrend(token: string, project: number,start:any,end:any) {
  return axios.get(`/performance/pkg_struct_trend/?project=${project}&start=${start}&end=${end}`, authHeaders(token));
},
async pkgabnormalTrend(token: string, project: number,start:any,end:any) {
  return axios.get(`/performance/abnormal_resource_trend/?project=${project}&start=${start}&end=${end}`, authHeaders(token));
},
async pkgMapStructTrend(token: string, project: number,start:any,end:any,filename:string) {
  return axios.get(`/performance/map_struct_trend/?project=${project}&start=${start}&end=${end}&filename=${filename}`, authHeaders(token));
},
// 自动化CPU函数
async deepPerformanceCpuLabels(token: string, project: number,start:string,end:string,device_id:number,scene_id:number,id_test:any) {
  return axios.get(`/deep_performance/cpu_func_labels/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&id_test=${id_test}`, authHeaders(token));
},
async deepPerformanceCpuUsageTrend(token: string, project: number,start:string,end:string,device_id:number,scene_id:number,is_auto:any,type:any,subtype:any,) {
  return axios.get(`/deep_performance/cpu_usage_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));
},
async deepPerformanceCpuLabelsOld(token: string, project: number,date:any,version:any,device_id:number,scene_id:number) {
  return axios.get(`/deep_performance/cpu_func_labels/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
},
async deepPerformanceCpuPerfTrend(token: string, project: number,device_id:number,scene_id:number) {
  return axios.get(`/deep_performance/cpu_perf_trend/?project=${project}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
},
async deepPerformanceCpuCustomTrend(token: string, project: number,device_id:number,scene_id:number) {
  return axios.get(`/deep_performance/speedm_custom_trend/?project=${project}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
},
async deepPerformanceCpuThreads(token: string, project: number,id_test:any) {
  return axios.get(`/deep_performance/cpu_func_threads/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deepPerformanceFpsInsideTrend(token: string, project: number,id_test:any) {
  return axios.get(`/performance/fps_second_trend/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deepPerformanceFlameGraphUrl(token: string, project: number,id_test:any) {
  return axios.get(`/deep_performance/flame_graph_url/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async deepPerformanceCpuTrend(token: string, project: number,start:string,end:string,device_id:number,scene_id:number,threads:any,label:any,id_test:any,is_auto:any,type:any,subtype:any,) {
  return axios.get(`/deep_performance/cpu_func_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&threads=${threads}&label=${label}&id_test=${id_test}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));
},
async deepPerformanceCpuThreadTrend(token: string, project: number,start:string,end:string,device_id:number,scene_id:number,id_test:any,is_auto:any,type:any,subtype:any,) {
  return axios.get(`/deep_performance/cpu_thread_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&id_test=${id_test}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));
},

async deepPerformanceCpuVersions(token: string, project: number,is_auto:any,type:any,subtype:any,device_id?:any,scene_id?:any) {
  if(device_id){
    return axios.get(`/deep_performance/cpu_func_versions/?project=${project}&is_auto=${is_auto}&type=${type}&subtype=${subtype}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
  }
    return axios.get(`/deep_performance/cpu_func_versions/?project=${project}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));


},
async deepPerformanceCpufuncTrend(token: string, project: number,name:string,is_auto:any,type:any,subtype:any,device_id:any,scene_id:any,thread:any) {

    return axios.get(`/deep_performance/func_trend/?project=${project}&name=${name}&is_auto=${is_auto}&type=${type}&subtype=${subtype}&device_id=${device_id}&scene_id=${scene_id}&thread=${thread}`, authHeaders(token));


},
async deepPerformanceCpuConfig(token: string, project: number,) {

    return axios.get(`/deep_performance/cpu_module_config/?project=${project}`, authHeaders(token));


},
async deepPerformanceCpuConfigSoList(token: string, project: number,id_test:any) {

    return axios.get(`/deep_performance/so_list/?project=${project}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCpuFunctionCos(token: string, project: number,thread:any,id_test:any) {

    return axios.get(`/deep_performance/cpu_func_sos/?project=${project}&thread=${thread}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceTrendNode(token: string, project: number,id_test:any,node_id:any,thread?:any) {
  if(thread){
    return axios.get(`/deep_performance/cpu_function_trend/?project=${project}&id_test=${id_test}&node_id=${node_id}&thread=${thread}`, authHeaders(token));
  }else{
    return axios.get(`/deep_performance/cpu_function_trend/?project=${project}&id_test=${id_test}&node_id=${node_id}`, authHeaders(token));
  }



},
async deepPerformanceCpuFunctionModel(token: string, project: number,threads:any,sos:any,id_test:any) {

    return axios.get(`/deep_performance/cpu_func_options/?project=${project}&threads=${threads}&sos=${sos}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCpuStack(token: string, project: number,id_test:any,frame:number,thread:any,) {

  return axios.get(`/deep_performance/cpu_func_stack/?project=${project}&id_test=${id_test}&frame=${frame}&thread=${thread}`, authHeaders(token));


},
async deepPerformanceCpuStackMerge(token: string, data:ICpuStackMerge) {

  return axios.post(`/deep_performance/cpu_func_stack_merge/`,data,authHeaders(token));


},
async deepPerformanceCpuReportText(token: string, data:{project: number,id_test,old_test:any,risk:string,text:any}) {

  return axios.post(`/deep_performance/cpu_report_text/`,data,authHeaders(token));


},
async deepPerformanceFrameProblem(token: string, data:{project: number,id_test:any,thread:string,timelines:any,start_time:any,end_time:any}) {

  return axios.post(`/deep_performance/frame_problem/`,data,authHeaders(token));


},
async tokenLibraryCreate(token: string, data:{project: number,token:string,expiration_time:string}) {

  return axios.post(`/peripheral_system/token_list/`,data,authHeaders(token));


},
async tokenLibraryList(token: string, project: number) {

  return axios.get(`/peripheral_system/token_list/?project=${project}`,authHeaders(token));


},
async perfettoText(token: string, data:{project: number,task_record_id:number,device_id:number,text:any}) {

  return axios.put(`/perfetto/perfetto_report/`,data,authHeaders(token));


},

async deepPerformanceCpuStackFind(token: string, project: number,id_test:number,frame:number,thread:any,abs_time:any,name:string) {

  return axios.get(`/deep_performance/cpu_func_stack_find/?project=${project}&id_test=${id_test}&frame=${frame}&thread=${thread}&abs_time=${abs_time}&name=${name}`, authHeaders(token));


},
async deepPerformanceCpuStackCreated(token: string, project: number,id_test:number,frame:number,depth:number,id_row:any,thread:any,abs_time:any) {

  return axios.get(`/deep_performance/cpu_func_stack_v1/?project=${project}&id_test=${id_test}&frame=${frame}&depth=${depth}&id_row=${id_row}&thread=${thread}&abs_time=${abs_time}`, authHeaders(token));


},
async deepPerformanceCpuStackCreatedOld(token: string, project: number,id_test:number,frame:number,depth:number,id_row:number,thread:any,abs_time) {

  return axios.get(`/deep_performance/cpu_func_stack_v1/?project=${project}&id_test=${id_test}&frame=${frame}&depth=${depth}&id_row=${id_row}&thread=${thread}&abs_time=${abs_time}`, authHeaders(token));


},
async deepPerformanceCpuVersionsOld(token: string, project: number,device_id?:number,scene_id?:number,is_auto?:any,type?:any,subtype?:any,) {

    return axios.get(`/deep_performance/cpu_func_versions/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));


},
async deepPerformanceCpuFunction(token: string, project: number,date:string,old_date:string,device_id:number,scene_id:number,game_version:string,old_version:string,id_test:any,thread:string,label:string,old_test:any) {

    return axios.get(`/deep_performance/cpu_function/?project=${project}&date=${date}&old_date=${old_date}&device_id=${device_id}&scene_id=${scene_id}&game_version=${game_version}&old_version=${old_version}&id_test=${id_test}&thread=${thread}&label=${label}&old_test=${old_test}`, authHeaders(token));


},
async deepPerformanceCpuFunctionOverview(token: string, project: number,date:string,old_date:string,device_id:number,scene_id:number,game_version:string,old_version:string,id_test:any,old_test:any) {

    return axios.get(`/deep_performance/cpu_func_overview/?project=${project}&date=${date}&old_date=${old_date}&device_id=${device_id}&scene_id=${scene_id}&game_version=${game_version}&old_version=${old_version}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));


},
async deepPerformanceCpuFunctionOverviewNew(token: string, project: number,id_test:any,old_test:any,threads?:any) {
 if(threads){
  return axios.get(`/deep_performance/cpu_func_overview/?project=${project}&id_test=${id_test}&old_test=${old_test}&threads=${threads}`, authHeaders(token));
 }else{
  return axios.get(`/deep_performance/cpu_func_overview/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));
 }



},
async deepPerformanceCpuThreadList(token: string, project: number,id_test:any,old_test:any) {

    return axios.get(`/deep_performance/cpu_thread_list/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));


},
async deepPerformanceCpuCustomData(token: string, project: number,id_test:any,old_test:any) {

    return axios.get(`/deep_performance/speedm_custom_data/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));


},
async deepPerformanceCpuUsageList(token: string, project: number,id_test:any,old_test:any,fps_rate:string) {

    return axios.get(`/deep_performance/cpu_usage_list/?project=${project}&id_test=${id_test}&old_test=${old_test}&fps_rate=${fps_rate}`, authHeaders(token));


},
async deepPerformanceCpuUsageListQQ(token: string, project: number,id_test:any,threads?:any ) {
   if(threads){
    return axios.get(`/performance/cpu_second_trend/?project=${project}&id_test=${id_test}&threads=${threads}`, authHeaders(token));
   }else{
    return axios.get(`/performance/cpu_second_trend/?project=${project}&id_test=${id_test}`, authHeaders(token));
   }



},
async deepPerformanceCpuUsageListModuleQQ(token: string, project: number,id_test:any, ) {

    return axios.get(`/performance/module_second_trend/?project=${project}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCpuReport(token: string, project: number,id_test:any,old_test:any) {

    return axios.get(`/deep_performance/cpu_report/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));


},
async deepPerformancefuncList(token: string, project: number,id_test:any,old_test?:any) {
 if(old_test){
  return axios.get(`/deep_performance/func_all/?project=${project}&id_test=${id_test}&old_test=${old_test}`, authHeaders(token));
 }else{
  return axios.get(`/deep_performance/func_all/?project=${project}&id_test=${id_test}`, authHeaders(token));
 }



},
async deepPerformanceCpuByFrame(token: string, project: number,date:string,device_id:number,scene_id:number,game_version?:string,id_test?:any,thread?:string) {
  if(game_version){
    return axios.get(`/deep_performance/cpu_func_by_frame/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&game_version=${game_version}&id_test=${id_test}&thread=${thread}`, authHeaders(token));
  }else{
    return axios.get(`/deep_performance/cpu_func_by_frame/?project=${project}&id_test=${id_test}`, authHeaders(token));
  }



},
async deepPerformanceCpuSoTrend(token: string,project: number,start:string,end:string,device_id:number,scene_id:number,thread:any,label:any,id_test:any) {

    return axios.get(`/deep_performance/cpu_so_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&thread=${thread}&label=${label}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCpuModuleTrend(token: string,project: number,start:string,end:string,device_id:number,scene_id:number,label:any,id_test:any,is_auto:any,type:any,subtype:any,) {

    return axios.get(`/deep_performance/cpu_module_trend/?project=${project}&start=${start}&end=${end}&device_id=${device_id}&scene_id=${scene_id}&label=${label}&id_test=${id_test}&is_auto=${is_auto}&type=${type}&subtype=${subtype}`, authHeaders(token));


},
async deepPerformanceCpuDetail(token: string,project: number,id_test:any) {

    return axios.get(`/deep_performance/cpu_func_detial/?project=${project}&id_test=${id_test}`, authHeaders(token));


},
// async deepPerformanceAvgStack(token: string,data:{project: number,id_test:any}) {

//     return axios.get(`/deep_performance/avg_stack/`,data, authHeaders(token));


// },
async deepPerformanceAvgStack(token: string, project: number,id_test:any) {

  return axios.get(`/deep_performance/avg_stack/?project=${project}&id_test=${id_test}`,authHeaders(token));


},
async deepPerformanceCputhreadByFrame(token: string,project: number,id_test:any) {

    return axios.get(`/deep_performance/cpu_thread_by_frame/?project=${project}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCatonList(token: string,project: number,id_test:any) {

    return axios.get(`/deep_performance/caton_list/?project=${project}&id_test=${id_test}`, authHeaders(token));


},
async deepPerformanceCatonCheck(token: string,project: number,start_time:any,device_id:any,scene_id:any,end_time:any) {

    return axios.get(`/deep_performance/caton_check/?project=${project}&start_time=${start_time}&device_id=${device_id}&scene_id=${scene_id}&end_time=${end_time}`, authHeaders(token));


},
async deepPerformanceCatonCreateList(token: string,data:{project: number,start_time:any,id_test:any,index:any,end_time:any,end_index:any,max_frame_index:any,max_frame_time:any,caton_id:any,frame_time:any,old_test:any}) {

    return axios.post(`/deep_performance/caton_list/`,data, authHeaders(token));


},
async deepPerformanceCpuPutDetail(token: string, data: { project: number, id_test: any, settings: any,old_test:any,label:any }) {
  return axios.put(`/deep_performance/cpu_func_detial/`, data, authHeaders(token));
},
async deepPerformanceSimpleDetail(token: string, data: { project: number, id_test: any,name:string }) {
  return axios.put(`/deep_performance/simple_report_detail/`, data, authHeaders(token));
},
async deepPerformanceCpuPutCheck(token: string, data: { project: number,  settings: any }) {
  return axios.put(`/deep_performance/cpu_func_check/`, data, authHeaders(token));
},
async deepPerformanceCpuPutConfig(token: string, data: { project: number,  id_test: any,module_config:any, }) {
  return axios.put(`/deep_performance/cpu_module_config/`, data, authHeaders(token));
},
async topDataEdit(token: string, data: { project: number,  version: any,project_id:any,test_time:string,valid:any }) {
  return axios.put(`/top/top_list/`, data, authHeaders(token));
},
async tokenLibraryEdit(token: string, data: { project: number,id:number,  token:string,expiration_time:string }) {
  return axios.put(`/peripheral_system/token/${data.id}/`, data, authHeaders(token));
},
// 安卓线进程性能监测

async androidOfflineDate(token: string,  project:number) {
  return axios.get(`/performance_log/offline_dates/?project=${project}`, authHeaders(token));
},
async perfettoOptions(token: string,  project:number,report_type:any,is_all:any) {
  return axios.get(`/perfetto/date_option/?project=${project}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async perfettoOldOptions(token: string,  project:number,report_type:any,is_all:any,device_id:any) {
  return axios.get(`/perfetto/date_option/?project=${project}&report_type=${report_type}&is_all=${is_all}&device_id=${device_id}`, authHeaders(token));
},
async perfettoDownLoadStack(token: string,  project:number,id:any,old_id,func:any,so:any) {
  return axios.get(`/perfetto/perfetto_stack_download/?project=${project}&id=${id}&old_id=${old_id}&func=${func}&so=${so}`, { headers: { 'Access-Token': token}, responseType: 'blob' });
},
async perfettoDownLoadDimensionStack(token: string,  project:number,id:any,old_id,func:any,so:any,dimension:any) {
  return axios.get(`/xcode/stack_download/?project=${project}&id=${id}&old_id=${old_id}&func=${func}&so=${so}&dimension=${dimension}`, { headers: { 'Access-Token': token}, responseType: 'blob' });
},
async perfettoFileName(token: string,  project:number,id:any,) {
  return axios.get(`/perfetto/filename/?project=${project}&id=${id}`, authHeaders(token));
},
async xcodeFileName(token: string,  project:number,id:any,) {
  return axios.get(`/xcode/filename/?project=${project}&id=${id}`, authHeaders(token));
},
async perfettoTypeOptions(token: string,  project:number,is_all:any) {
  return axios.get(`/perfetto/type_option/?project=${project}&is_all=${is_all}`, authHeaders(token));
},
async xcodeTypeOptions(token: string,  project:number,type:any) {
  return axios.get(`/xcode/type_option/?project=${project}&type=${type}`, authHeaders(token));
},
async xcodeDateOptions(token: string,  project:number,type:any,report_type:any) {
  return axios.get(`/xcode/date_option/?project=${project}&type=${type}&report_type=${report_type}`, authHeaders(token));
},
async xcodeDeviceOptions(token: string,  project:number,type:any,report_type:any,date:any,version:any) {
  return axios.get(`/xcode/device_option/?project=${project}&type=${type}&report_type=${report_type}&date=${date}&version=${version}`, authHeaders(token));
},
async xcodeDimensionsOptions(token: string,  project:number,type:any,report_type:any,date:any,version:any,device_id:any) {
  return axios.get(`/xcode/dimensions/?project=${project}&type=${type}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));
},
async xcodeLevelOptions(token: string,  project:number,type:any,report_type:any,date:any,version:any,device_id:any,) {
  return axios.get(`/xcode/level_option/?project=${project}&type=${type}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));
},
async xcodeSceneOptions(token: string,  project:number,type:any,report_type:any,date:any,version:any,device_id:any,) {
  return axios.get(`/xcode/scene_option/?project=${project}&type=${type}&report_type=${report_type}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));
},
async perfettoSettings(token: string,  project:number) {
  return axios.get(`/proj/project_setting/?project=${project}`, authHeaders(token));
},
async performanceSvgLog(token: string,  project:number) {
  return axios.get(`/performance_log/svn_log_list/?project=${project}`, authHeaders(token));
},
async performanceDsLog(token: string,  project:number) {
  return axios.get(`/performance_log/ds_log_list/?project=${project}`, authHeaders(token));
},
async performanceSvgLogData(token: string,  project:number,id:any,page:any,size:any) {
  return axios.get(`/performance_log/svn_log/?project=${project}&id=${id}&page=${page}&size=${size}`, authHeaders(token));
},
async performanceDsLogData(token: string,  project:number,id:any,page:any,size:any) {
  return axios.get(`/performance_log/ds_log/?project=${project}&id=${id}&page=${page}&size=${size}`, authHeaders(token));
},
async perfettoSettingsEdit(token: string,  data: { project: number,  settings: any }) {
  return axios.put(`/proj/project_setting/`,data, authHeaders(token));
},
async putLightSmoke(token: string,  data: { project: number,  id: any,index:any,result:any,remark:any,bug_url:any,problem_type:any,light_type:any,mark:any,ai_check:any,ai_check_res?:any }) {
  return axios.put(`/report/light_smoke/`,data, authHeaders(token));
},
async putAabnormalResourceList(token: string,  data: { project: number,  id: any,is_ignore:any }) {
  return axios.put(`/performance/abnormal_resource/`,data, authHeaders(token));
},
async putResourceConfig(token: string,  data: { project: number,  name: any,value:any,level:any,}) {
  return axios.put(`/memory/resource_config/`,data, authHeaders(token));
},
async putAssetStack(token: string,  data: { project: number,  id: any,is_ignore:any }) {
  return axios.put(`/performance/pkg_asset_stack/`,data, authHeaders(token));
},
async putmemoryConfig(token: string,  data: { project: number,  key: any,value:any }) {
  return axios.put(`/memory/memory_config/`,data, authHeaders(token));
},
async perfettoDeviceOptions(token: string,  project:number,date:string,version:string,report_type:any,is_all:any) {
  return axios.get(`/perfetto/device_option/?project=${project}&date=${date}&version=${version}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async perfettoLevelOptions(token: string,  project:number,date:string,version:string,device_id:any,report_type:any,is_all:any) {
  return axios.get(`/perfetto/level_option/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async perfettoStack(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,is_all:any) {
  return axios.get(`/perfetto/perfetto_stack/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&is_all=${is_all}`, authHeaders(token));
},
async xcodeStack(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,size:any,so:any,func:any,type:any,dimension:any,option:any) {
  return axios.get(`/xcode/xcode_stack/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&size=${size}&so=${so}&func=${func}&type=${type}&dimension=${dimension}&option=${option}`, authHeaders(token));
},
async perfettoStackSearch(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,size:any,so:any,func:any) {
  return axios.get(`/perfetto/perfetto_stack/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&size=${size}&so=${so}&func=${func}`, authHeaders(token));
},
async perfettoStackSearch_v2(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,size:any,so:any,func:any,old_date:any,old_version:any,is_all:any) {
  return axios.get(`/perfetto/perfetto_stack_v2/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&size=${size}&so=${so}&func=${func}&old_date=${old_date}&old_version=${old_version}&is_all=${is_all}`, authHeaders(token));
},
async perfettoStackSearchFuncitons(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,func:any) {
  return axios.get(`/perfetto/perfetto_stack/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&func=${func}`, authHeaders(token));
},
async perfettoStackSearchSo(token: string,  project:number,level:any,date:string,version:string,device_id:any,report_type:any,scene_name:any,so:any) {
  return axios.get(`/perfetto/perfetto_stack/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&scene_name=${scene_name}&so=${so}`, authHeaders(token));
},
async perfettoTraces(token: string,  project:number,date:any,version:any,device_id:any,scene_name:any,level:any) {
  return axios.get(`/perfetto/trace/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&scene_name=${scene_name}&level=${level}`, authHeaders(token));
},
async perfettoSceneOptions(token: string,  project:number,date:string,version:string,device_id:any,report_type:any,is_all:any) {
  return axios.get(`/perfetto/scene_option/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async perfettoNativeTrend(token: string,  project:number,level:any,report_type:number|'',start:any,end:any,is_all:any) {
  return axios.get(`/perfetto/native_trend/?project=${project}&level=${level}&report_type=${report_type}&start=${start}&end=${end}&is_all=${is_all}`, authHeaders(token));
},
async xcodeNativeTrend(token: string,  project:number,level:any,report_type:number|'',start:any,end:any,type:any,scene_name:any) {
  return axios.get(`/xcode/native_trend/?project=${project}&level=${level}&report_type=${report_type}&start=${start}&end=${end}&type=${type}&scene_name=${scene_name}`, authHeaders(token));
},
async perfettoNativeFuncTrend(token: string,  project:number,level:any,report_type:number|'',scene_id:any,start:string,end:string,is_all:any) {
  return axios.get(`/perfetto/func_trend/?project=${project}&level=${level}&report_type=${report_type}&scene_id=${scene_id}&start=${start}&end=${end}&is_all=${is_all}`, authHeaders(token));
},
async xcodeNativeFuncTrend(token: string,  project:number,level:any,report_type:number|'',scene_name:any,start:string,end:string,type:any,dimension:any) {
  return axios.get(`/xcode/func_trend/?project=${project}&level=${level}&report_type=${report_type}&scene_name=${scene_name}&start=${start}&end=${end}&type=${type}&dimension=${dimension}`, authHeaders(token));
},
async perfettoSoFuncTrend(token: string, data:{ project:number,level:any,report_type:number|'',scene_id:any,start:string,end:string,so_list:any,is_all:any}) {
  return axios.post(`/perfetto/so_trend/`,data, authHeaders(token));
},
async xcodeSoFuncTrend(token: string, data:{ project:number,level:any,report_type:number|'',scene_name:any,start:string,end:string,so_list:any,type:any,dimension:any}) {
  return axios.post(`/xcode/so_trend/`,data, authHeaders(token));
},
async svgLoagUpload(token: string, data:{project:any,name:any,file:any }) {
  return axios.post(`/performance_log/svn_log_upload/`,data, authHeaders(token));
},
async memoeryUpload(token: string, data:{project:any,task_id:any,device:any,scenes:any,version:any,up_file:any,tips_up:any }) {
  return uploadAxios.post('/submitLog/',data, authHeaders(token));
},
async dsLoagUpload(token: string, data:{project:any,name:any,file:any }) {
  return axios.post(`/performance_log/ds_log_upload/`,data, authHeaders(token));
},
async nzmSimpleUpload(token: string, data:{project:any,name:any,file:any,scene_id:any,script_id:any,task_record_id:any,UUID:any }) {
  return axios.post(`/deep_performance/manual_upload/`,data, authHeaders(token));
},
async perfettoNativeModule(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_id:any,report_type:any,is_all:any,order_by:any,reverse:any) {
  return axios.get(`/perfetto/native_module/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_id=${scene_id}&report_type=${report_type}&is_all=${is_all}&order_by=${order_by}&reverse=${reverse}`, authHeaders(token));
},
async perfettoSoList(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_id:any,report_type:any,is_all:any) {
  return axios.get(`/perfetto/so_list/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_id=${scene_id}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async perfettoModuleTrend(token: string,  project:number,level:any,report_type:any,scene_name:any,is_all:any) {
  return axios.get(`/perfetto/module_trend/?project=${project}&level=${level}&report_type=${report_type}&scene_name=${scene_name}&is_all=${is_all}`, authHeaders(token));
},
async perfettoModuleList(token: string,  project:number,level:any,report_type:any,scene_name:any,is_all:any) {
  return axios.get(`/perfetto/module_list/?project=${project}&level=${level}&report_type=${report_type}&scene_name=${scene_name}&is_all=${is_all}`, authHeaders(token));
},
async xcodeSoList(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,report_type:any,type:any,dimension:any) {
  return axios.get(`/xcode/so_list/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&report_type=${report_type}&type=${type}&dimension=${dimension}`, authHeaders(token));
},
async xcodeNativeModule(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,report_type:any,type:any,dimension:any,option:any) {
  return axios.get(`/xcode/native_module/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&report_type=${report_type}&type=${type}&dimension=${dimension}&option=${option}`, authHeaders(token));
},
async perfettoNativeAll(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_id:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,is_all:any) {
  return axios.get(`/perfetto/native_all/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_id=${scene_id}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&is_all=${is_all}`, authHeaders(token));
},
async xcodeNativeAll(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,type:any,dimension:any) {
  return axios.get(`/xcode/native_all/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&type=${type}&dimension=${dimension}`, authHeaders(token));
},
async perfettoSoAll(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_id:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,is_all:any) {
  return axios.get(`/perfetto/so_all/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_id=${scene_id}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&is_all=${is_all}`, authHeaders(token));
},
async xcodeSoAll(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,type:any,dimension:any) {
  return axios.get(`/xcode/so_all/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&type=${type}&dimension=${dimension}`, authHeaders(token));
},
async ObjectFuncAll(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,report_type:any) {
  return axios.get(`/object_memory/func_all/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&report_type=${report_type}`, authHeaders(token));
},
async perfettoNativeAllExport(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_id:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any) {
  return axios.get(`/perfetto/native_export/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_id=${scene_id}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );
},
async xcodeNativeAllExport(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,type:any,dimension:any) {
  return axios.get(`/xcode/native_export/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&type=${type}&dimension=${dimension}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );
},
async perfettoObjectAllExport(token: string,  project:number,level:any,device_id:number|'',date:string,version:string,scene_name:any,top:any,search:any,old_date:string,old_version:string,order_by:any,reverse:any,report_type:any) {
  return axios.get(`/object_memory/func_export/?project=${project}&level=${level}&device_id=${device_id}&date=${date}&version=${version}&scene_name=${scene_name}&top=${top}&search=${search}&old_date=${old_date}&old_version=${old_version}&order_by=${order_by}&reverse=${reverse}&report_type=${report_type}`, { headers: { 'Access-Token': token}, responseType: 'blob' } );
},
async perfettoReport(token: string,  project:number,date:string,version:string,device_id:any,report_type:any,is_all:any) {
  return axios.get(`/perfetto/perfetto_report/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&is_all=${is_all}`, authHeaders(token));
},
async xcodeReport(token: string,  project:number,date:string,version:string,device_id:any,report_type:any,type:any,) {
  return axios.get(`/xcode/perfetto_report/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&type=${type}`, authHeaders(token));
},
async perfettoMap(token: string,  project:number,level:any,task_record_id:any,device_id:any,scene_name:any) {
  return axios.get(`/perfetto/fire_map/?project=${project}&level=${level}&task_record_id=${task_record_id}&device_id=${device_id}&scene_name=${scene_name}`, authHeaders(token));
},
async perfettoMapData(token: string,  project:number,level:any,date:any,version:any,device_id:any,scene_name:any) {
  return axios.get(`/perfetto/fire_map_data/?project=${project}&level=${level}&date=${date}&version=${version}&device_id=${device_id}&scene_name=${scene_name}`, authHeaders(token));
},
async androidOfflineOldDate(token: string,  project:number,device_id:number,scene_id:number,subtype:any) {
  return axios.get(`/performance_log/offline_dates/?project=${project}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`, authHeaders(token));
},
async androidOfflineDevice(token: string,  project:number,date:string) {
  return axios.get(`/performance_log/offline_devices/?project=${project}&date=${date}`, authHeaders(token));
},
async androidOfflineScenes(token: string,  project:number,date:string,device_id:number) {
  return axios.get(`/performance_log/offline_scenes/?project=${project}&date=${date}&device_id=${device_id}`, authHeaders(token));
},
async androidOfflineSubtypes(token: string,  project:number,date:string,device_id:number,scene_id:number) {
  return axios.get(`/performance_log/offline_subtypes/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}`, authHeaders(token));
},
async androidOfflineList(token: string,  project:number,date:string,device_id:number,scene_id:number,subtype:any) {
  return axios.get(`/performance_log/offline_list/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`, authHeaders(token));
},
async androidOfflineOldList(token: string,  project:number,date:string,device_id:number,scene_id:number,subtype:any) {
  return axios.get(`/performance_log/offline_list/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`, authHeaders(token));
},
async androidOfflineThreadOldList(token: string,  project:number,date:string,device_id:number,scene_id:number,subtype:any) {
  return axios.get(`/performance_log/offline_list/?project=${project}&date=${date}&device_id=${device_id}&scene_id=${scene_id}&subtype=${subtype}`, authHeaders(token));
},
async androidThreadOptions(token: string,  project:number,id_test:number,type:number) {
  return axios.get(`/performance_log/offline_options/?project=${project}&id_test=${id_test}&type=${type}`, authHeaders(token));
},
async androidThreadCompare(token: string,  project:number,id_test:number,type:number,old_test:any) {
  return axios.get(`/performance_log/offline_compare_list/?project=${project}&id_test=${id_test}&type=${type}&old_test=${old_test}`, authHeaders(token));
},
async androidCourseCompare(token: string,  project:number,id_test:number,type:number,old_test:any) {
  return axios.get(`/performance_log/offline_compare_list/?project=${project}&id_test=${id_test}&type=${type}&old_test=${old_test}`, authHeaders(token));
},
async androidCourseOptions(token: string,  project:number,id_test:number,type:number) {
  return axios.get(`/performance_log/offline_options/?project=${project}&id_test=${id_test}&type=${type}`, authHeaders(token));
},
async androidOfflineZip(token: string,  project:number,id_test:number,) {
  return axios.get(`/performance_log/offline_zip/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async androidOfflineUrl(token: string,  project:number,id_test:number,) {
  return axios.get(`/performance_log/offline_pipeline_url/?project=${project}&id_test=${id_test}`, authHeaders(token));
},
async androidCourseTrend(token: string,  project:number,id_test:number,type:number,names:any, start:any, end:any) {
  return axios.get(`/performance_log/offline_trend/?project=${project}&id_test=${id_test}&type=${type}&names=${names}&start=${start || ''}&end=${end || ''}`, authHeaders(token));
},
async androidThreadTrend(token: string,  project:number,id_test:number,type:number,names:any, start:any, end:any) {
  return axios.get(`/performance_log/offline_trend/?project=${project}&id_test=${id_test}&type=${type}&names=${names}&start=${start || ''}&end=${end || ''}`, authHeaders(token));
},
async androidCourseProcessList(token: string,  project:number,id_test:number,type:number,search:string,size: number | string, page: number) {
  return axios.get(`/performance_log/offline_process_list/?project=${project}&id_test=${id_test}&type=${type}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
},
async androidThreadProcessList(token: string,  project:number,id_test:number,type:number,search:string,size: number | string, page: number) {
  return axios.get(`/performance_log/offline_process_list/?project=${project}&id_test=${id_test}&type=${type}&search=${search}&size=${size}&page=${page}`, authHeaders(token));
},
// CPU性能报告
async deepPerformanceCpuFuncReport(token: string, project: number,id_test:number,old_test:number,thread:string,so:string) {

  return axios.get(`/deep_performance/cpu_func_report/?project=${project}&id_test=${id_test}&old_test=${old_test}&thread=${thread}&so=${so}`, authHeaders(token));


},
// TOP数据
async topPerformance(token: string,  project:number|'',page:number,size:number,label:any,model:any,level:number|'',tester:string,project_name:any,is_sub:any) {
  return axios.get(`/performance/top_performances/?project=${project}&page=${page}&size=${size}&label=${encodeURIComponent(label)}&model=${model}&level=${level}&tester=${tester}&project_name=${project_name}&is_sub=${is_sub}`, authHeaders(token));
},
async topPerformanceList(token: string,  project:number|'',page:number,size:number,project_id:any,model_name:any,version:any) {
  return axios.get(`/top/top_list/?project=${project}&page=${page}&size=${size}&project_id=${project_id}&model_name=${model_name}&version=${version}`, authHeaders(token));
},
async topPerformanceList_advance(token: string,  project:number|'',page:number,size:number,project_id:any,is_valid:number,version:any,test_time:string) {
  return axios.get(`/top/top_list/?project=${project}&page=${page}&size=${size}&project_id=${project_id}&is_valid=${is_valid}&version=${version}&test_time=${test_time}`, authHeaders(token));
},
async topPerformanceOld(token: string,  project:number|'',page:number,size:number,label:any,model:any,level:number|'',tester:string,project_name:any,id_test:any,label_main:any) {
  return axios.get(`/performance/top_performances/?project=${project}&page=${page}&size=${size}&label=${encodeURIComponent(label)}&model=${model}&level=${level}&tester=${tester}&project_name=${project_name}&id_test=${id_test}&label_main=${label_main}`, authHeaders(token));
},
async topProjectPerformance(token: string,  project:number,) {
  return axios.get(`/performance/top_project_option/?project=${project}`, authHeaders(token));
},
async topOptions(token: string,  project:number,) {
  return axios.get(`/top/top_options/?project=${project}`, authHeaders(token));
},
async topLabelPerformance(token: string,  project:number|'',project_name:any) {
  return axios.get(`/performance/top_label_option/?project=${project}&project_name=${project_name}`, authHeaders(token));
},
async topMainLabelPerformance(token: string,  project:number|'',project_name:any) {
  return axios.get(`/performance/top_main_label_option/?project=${project}&project_name=${project_name}`, authHeaders(token));
},
async topModelPerformance(token: string,  project:number|'',) {
  return axios.get(`/performance/top_model_option/?project=${project}`, authHeaders(token));
},
async topLevelPerformance(token: string,  project:number|'',) {
  return axios.get(`/performance/top_level_option/?project=${project}`, authHeaders(token));
},
async topTesterPerformance(token: string,  project:number|'',) {
  return axios.get(`/performance/top_tester_option/?project=${project}`, authHeaders(token));
},
async topCpuList(token: string,  project:number|'',search:any) {
  return axios.get(`/top/cpu_list/?project=${project}&search=${search}`, authHeaders(token));
},
async topProjectList(token: string,  project:number|'',) {
  return axios.get(`/top/project_list/?project=${project}`, authHeaders(token));
},
async topProblemSummary(token: string,  project:number|'',top_project:any,type:any,version:any) {
  return axios.get(`/top/problem_summary/?project=${project}&top_project=${top_project}&type=${type}&version=${version}`, authHeaders(token));
},
async topProblemByCpu(token: string,  project:number|'',type:number|'',cpu_name:string) {
  return axios.get(`/top/problem_by_cpu/?project=${project}&type=${type}&cpu_name=${cpu_name}`, authHeaders(token));
},
async topSceneList(token: string,  project:number|'',project_list:any,type:number) {
  return axios.get(`/top/scene_list/?project=${project}&project_list=${project_list}&type=${type}`, authHeaders(token));
},
async topSceneListVersion(token: string,  project:number|'',top_project:any,type:number) {
  return axios.get(`/top/scene_list/?project=${project}&top_project=${top_project}&type=${type}`, authHeaders(token));
},
async topModelList(token: string,  project:number|'',project_list:any,type:number,scene_list:any) {
  return axios.get(`/top/model_list/?project=${project}&project_list=${project_list}&type=${type}&scene_list=${scene_list}`, authHeaders(token));
},
async topModelListVersion(token: string,  project:number|'',top_project:any,type:number,scene:any) {
  return axios.get(`/top/model_list/?project=${project}&top_project=${top_project}&type=${type}&scene=${scene}`, authHeaders(token));
},
async topVersionList(token: string,  project:number|'',project_list:any,type:number,scene_list:any,model_list:any) {
  return axios.get(`/top/version_list/?project=${project}&project_list=${project_list}&type=${type}&scene_list=${scene_list}&model_list=${model_list}`, authHeaders(token));
},
async topVersionListVersion(token: string,  project:number|'',top_project:any,type:number,scene:any,model_list:any) {
  return axios.get(`/top/version_list/?project=${project}&top_project=${top_project}&type=${type}&scene=${scene}&model_list=${model_list}`, authHeaders(token));
},
async topProjectType(token: string,  project:number|'',project_list:any,type:any,scene_list:any,model_list:any,version:any) {
  return axios.get(`/top/project_perfdata/?project=${project}&project_list=${project_list}&type=${type}&scene_list=${scene_list}&model_list=${model_list}&version=${version}`, authHeaders(token));
},
async topVersionData(token: string,  project:number|'',top_project:any,type:any,scene:any,model_list:any,version_list:any) {
  return axios.get(`/top/version_data/?project=${project}&top_project=${top_project}&type=${type}&scene=${scene}&model_list=${model_list}&version_list=${version_list}`, authHeaders(token));
},
async deletetopPerformance(token: string,  project:number|'',id_list:any) {
  return axios.delete(`/performance/top_perdog_upload/?project=${project}&id_list=${id_list}`, authHeaders(token));
},
// 测试预约
async testAppointment(token: string,  project:number|'',start:string,end:string,wereport_token:any) {
  return axios.get(`/timetable/timetable_list/?project=${project}&start=${start}&end=${end}&wereport_token=${wereport_token}`, authHeaders(token));
},
async testAppointmentAdamins(token: string,  project:number|'',wereport_token:any) {

  return axios.get(`/timetable/admins/?project=${project}&wereport_token=${wereport_token}`, authHeaders(token));
},
async testAppointmentTable(token: string,  project:number|'',is_origin:number,page:number,size:number,wereport_token:any,type?:any,) {
  if(type||type==''){
    return axios.get(`/timetable/timetable_by_page/?project=${project}&is_origin=${is_origin}&page=${page}&size=${size}&wereport_token=${wereport_token}&type=${type}`, authHeaders(token));
  }else{
    return axios.get(`/timetable/timetable_by_page/?project=${project}&is_origin=${is_origin}&page=${page}&size=${size}&wereport_token=${wereport_token}`, authHeaders(token));
  }

},
async testAppointmentCreat(token: string,  data:AppointmentCreat,) {
  return axios.post(`/timetable/timetable_list/`,data, authHeaders(token));
},
async testAppointmentEdit(token: string,  data:AppointmentCreat,) {
  return axios.put(`/timetable/timetable/${data.id}/`,data, authHeaders(token));
},
async deletePerfetto(token: string,  project:number,date:string,version:string,device_id:any) {
  return axios.delete(`/perfetto/perfetto_upload/?project=${project}&date=${date}&version=${version}&device_id=${device_id}`, authHeaders(token));
},
async deleteXcode(token: string,  project:number,date:string,version:string,device_id:any,report_type:any,type:any) {
  return axios.delete(`/xcode/xcode_upload/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}&type=${type}`, authHeaders(token));
},
async deleteObject(token: string,  project:number,date:string,version:string,device_id:any,report_type) {
  return axios.delete(`/object_memory/upload/?project=${project}&date=${date}&version=${version}&device_id=${device_id}&report_type=${report_type}`, authHeaders(token));
},
async deleteRowObject(token: string,  project:number,id:any) {
  return axios.delete(`/object_memory/upload/?project=${project}&id=${id}`, authHeaders(token));
},
async testAppointmentDelete(token: string,  id:number,projecet:number,wereport_token:any) {
  return axios.delete(`/timetable/timetable/${id}/?project=${projecet}`, authHeaders(token));
},
async deepPerformanceCatonDelete(token: string,  id:any,projecet:number) {
  return axios.delete(`/deep_performance/caton_detail/${id}/?project=${projecet}`, authHeaders(token));
},
async deepPerformanceSvgLogList(token: string,  projecet:number,id:any,) {
  return axios.delete(`/performance_log/svn_log_list/?project=${projecet}&id=${id}`, authHeaders(token));
},
async deletePerformanceImges(token: string,  projecet:number,id_test:any,) {
  return axios.delete(`/performance/performance_images/?project=${projecet}&id_test=${id_test}`, authHeaders(token));
},
async deepPerformanceDsLogList(token: string,  projecet:number,id:any,) {
  return axios.delete(`/performance_log/ds_log_list/?project=${projecet}&id=${id}`, authHeaders(token));
},
async deleteMemory(token: string,  projecet:number,id_test:any,) {
  return axios.delete(`/memory/speedm_memory_upload/?project=${projecet}&id_test=${id_test}`, authHeaders(token));
},
async upLoadMemoryResult(token: string,  data:{project:number,version:any,device_id:any,scene_name:any,file:any,tips_up:any}) {
  return axios.post(`/memory/speedm_memory_upload/`,data, authHeaders(token));
},
async deepPerformanceDeviceModel(token: string,  projecet:number,id:any,) {
  return axios.delete(`/device/model/${id}/?project=${projecet}`, authHeaders(token));
},
async deleteSkinTab(token: string,  projecet:number,id:any,) {
  return axios.delete(`/report/skin_tab/${id}/?project=${projecet}`, authHeaders(token));
},
};
